<template>
	<div class="gestionar-propuestas-compras-page">
		<!-- Modal inicial: Seleccionar propuesta -->
		<el-dialog
			title="Gestionar Propuestas - Compras"
			:visible.sync="modalInicial.visible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			width="500px"
			class="modal-inicial-propuesta"
		>
			<div v-if="loadingInicial" style="text-align: center; padding: 2rem;" v-loading="true" element-loading-text="Cargando...">
				<p style="font-size: 1.1rem; margin-top: 3rem;">Cargando...</p>
			</div>
			<div v-else>
				<p style="text-align: center; margin-bottom: 1rem; font-size: 1.1rem;">
					Seleccione una propuesta para gestionar:
				</p>
				<el-select
					v-model="propuestaSeleccionada"
					placeholder="Seleccione una propuesta"
					filterable
					style="width: 100%"
					:loading="loadingPropuestas"
					@change="cargarPropuestaSeleccionada"
				>
					<el-option
						v-for="prop in listaPropuestas"
						:key="prop.id"
						:label="getLabelPropuesta(prop)"
						:value="prop.id"
					/>
				</el-select>
				<div style="margin-top: 15px; text-align: center;">
					<el-button type="text" @click="volverAlDashboard">
						<i class="el-icon-back"></i> Volver al Dashboard
					</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- Modal cerrar propuesta -->
		<el-dialog
			title="Cerrar propuesta"
			:visible.sync="modalCerrarPropuesta.visible"
			width="520px"
			:close-on-click-modal="false"
		>
			<p style="margin-top: 0; margin-bottom: 10px;">
				Puede indicar un mensaje de cierre (opcional):
			</p>
			<el-input
				type="textarea"
				v-model="modalCerrarPropuesta.mensaje"
				:autosize="{ minRows: 3, maxRows: 6 }"
				placeholder="Mensaje opcional"
			/>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalCerrarPropuesta.visible = false" :disabled="modalCerrarPropuesta.cerrando">Cancelar</el-button>
				<el-button type="danger" @click="confirmarCerrarPropuesta" :loading="modalCerrarPropuesta.cerrando">Confirmar</el-button>
			</div>
		</el-dialog>

		<!-- Modal para seleccionar proveedor / lanzar orden de compra -->
		<el-dialog
			:title="tituloModalProveedor"
			:visible.sync="modalProveedor.visible"
			:width="anchoModalProveedor"
		>
			<el-form v-if="modalProveedor.accion === 'ordenCompra'" label-width="180px" class="form-orden-compra">
				<el-form-item label="Proveedor:" required>
					<el-input
						:value="nombreProveedorSeleccionadoModal"
						readonly
						disabled
					/>
				</el-form-item>
				<el-form-item label="Sección pedido:" required>
					<el-select
						v-model="formOrdenCompra.idSeccionesPedido"
						placeholder="Seleccione sección"
						filterable
						clearable
						style="width: 100%"
						:loading="loadingOpcionesOrdenCompra"
					>
						<el-option
							v-for="item in opcionesOrdenCompra.secciones_pedido"
							:key="item.id"
							:label="item.nombre || item.codigo || String(item.id)"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="Tipo envío:" required>
					<el-select
						v-model="formOrdenCompra.idTipoEnvio"
						placeholder="Seleccione tipo envío"
						filterable
						clearable
						style="width: 100%"
						:loading="loadingOpcionesOrdenCompra"
					>
						<el-option
							v-for="item in opcionesOrdenCompra.tipo_envio"
							:key="item.id"
							:label="item.nombre || item.codigo || String(item.id)"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="Condiciones envío:" required>
					<el-select
						v-model="formOrdenCompra.idCondicionesEnvio"
						placeholder="Seleccione condiciones envío"
						filterable
						clearable
						style="width: 100%"
						:loading="loadingOpcionesOrdenCompra"
					>
						<el-option
							v-for="item in opcionesOrdenCompra.condiciones_envio"
							:key="item.id"
							:label="item.nombre || item.codigo || String(item.id)"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="Plazo entrega (días):" required>
					<el-input-number
						v-model="formOrdenCompra.plazoEntrega"
						:min="0"
						:max="9999"
						:precision="0"
						controls-position="right"
						style="width: 100%"
					/>
				</el-form-item>
				<el-form-item label="Condiciones pedido:" required>
					<el-select
						v-model="formOrdenCompra.idCondicionesPedido"
						placeholder="Seleccione condiciones pedido"
						filterable
						clearable
						style="width: 100%"
						:loading="loadingOpcionesOrdenCompra"
					>
						<el-option
							v-for="item in opcionesOrdenCompra.condiciones_pedido"
							:key="item.id"
							:label="item.nombre || item.codigo || String(item.id)"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="Forma de pago:" required>
					<el-select
						v-model="formOrdenCompra.idFormaPago"
						placeholder="Seleccione forma de pago"
						filterable
						clearable
						style="width: 100%"
						:loading="loadingOpcionesOrdenCompra"
					>
						<el-option
							v-for="item in opcionesOrdenCompra.formas_pago"
							:key="item.id"
							:label="item.nombre || String(item.id)"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="Divisa:" required>
					<el-select
						v-model="formOrdenCompra.idDivisa"
						placeholder="Seleccione divisa"
						filterable
						clearable
						style="width: 100%"
						:loading="loadingOpcionesOrdenCompra"
					>
						<el-option
							v-for="item in opcionesOrdenCompra.divisas"
							:key="item.id"
							:label="(item.codigo || item.nombre || '').trim() || String(item.id)"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="Dirección de entrega:" required>
					<el-select
						v-model="formOrdenCompra.idDireccionEntrega"
						placeholder="Seleccione dirección de entrega"
						filterable
						clearable
						style="width: 100%"
						:loading="loadingOpcionesOrdenCompra"
						@change="onDireccionEntregaChange"
					>
						<el-option
							v-for="item in opcionesOrdenCompra.direcciones_entrega"
							:key="item.id"
							:label="item.destino || item.direccion || String(item.id)"
							:value="item.id"
						/>
						<el-option
							key="otros"
							label="Otros"
							value="__otros__"
						/>
					</el-select>
					<el-input
						v-if="formOrdenCompra.idDireccionEntrega"
						type="textarea"
						v-model="direccionEntregaTexto"
						:autosize="{ minRows: 2, maxRows: 5 }"
						:readonly="!esDireccionEntregaOtros"
						:placeholder="esDireccionEntregaOtros ? 'Indique la dirección de entrega' : ''"
						style="margin-top: 8px;"
					/>
				</el-form-item>
				<el-form-item label="Motivo aceptación oferta:">
					<el-input
						v-model="formOrdenCompra.motivoAceptacionOferta"
						type="textarea"
						:autosize="{ minRows: 2, maxRows: 5 }"
						placeholder="Indique el motivo de aceptación (opcional)"
					/>
				</el-form-item>
			</el-form>
			<div v-else-if="modalProveedor.accion === 'ordenCompraPreview'" class="modal-lanzar-oferta">
				<el-select
					v-model="modalProveedor.proveedorSeleccionado"
					placeholder="Seleccione un proveedor"
					filterable
					style="width: 100%"
					:loading="loadingProveedores"
				>
					<el-option
						v-for="prov in proveedoresAsignados"
						:key="prov.id"
						:label="prov.nombre"
						:value="prov.id"
					/>
				</el-select>
				<el-form
					v-if="modalProveedor.proveedorSeleccionado"
					label-width="150px"
					class="form-orden-compra form-orden-compra-preview"
				>
					<el-row :gutter="16" class="form-orden-compra-preview-row">
						<el-col :span="12">
							<el-form-item label="Dto. general pedido:">
								<div class="form-orden-compra-descuento-general">
									<el-input-number
										v-model="formOrdenCompra.descuentoGeneralPedido"
										:min="0"
										:max="100"
										:precision="2"
										:step="0.01"
										controls-position="right"
										style="width: 100%"
									/>
									<span class="form-orden-compra-suffix">%</span>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="Portes:">
								<div class="form-orden-compra-descuento-general">
									<el-input-number
										v-model="formOrdenCompra.portes"
										:min="0"
										:precision="2"
										:step="0.01"
										controls-position="right"
										style="width: 100%"
									/>
									<span class="form-orden-compra-suffix">€</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<div v-if="modalProveedor.proveedorSeleccionado" class="preview-oferta-section">
					<p class="preview-oferta-titulo">Líneas incluidas en la orden de compra</p>
					<el-table
						v-if="lineasPreviewOrdenCompra.length"
						:data="lineasPreviewOrdenCompra"
						border
						size="small"
						max-height="320"
						style="width: 100%"
					>
						<el-table-column prop="posicion" label="Pos." width="56" align="center" />
						<el-table-column prop="referencia" label="Referencia" min-width="100" show-overflow-tooltip />
						<el-table-column prop="equipo" label="Equipo" min-width="160" show-overflow-tooltip />
						<el-table-column prop="cantidad" label="Cantidad" width="80" align="right" />
						<el-table-column prop="unidad" label="Unidad" width="80" align="center" />
						<el-table-column label="Precio" width="90" align="right">
							<template slot-scope="{ row }">{{ formatImporteMoneda(row.precio) }}</template>
						</el-table-column>
						<el-table-column label="Dto." width="80" align="right">
							<template slot-scope="{ row }">{{ formatPorcentaje(row.descuento) }}</template>
						</el-table-column>
						<el-table-column label="Importe" width="100" align="right">
							<template slot-scope="{ row }">{{ formatImporteMoneda(row.importe) }}</template>
						</el-table-column>
					</el-table>
					<div v-if="lineasPreviewOrdenCompra.length" class="preview-orden-compra-totales">
						<div class="preview-orden-compra-totales-row">
							<span>Subtotal</span>
							<strong>{{ formatImporteMoneda(previewOrdenCompraSubtotal) }}</strong>
						</div>
						<div
							v-if="previewOrdenCompraDescuentoPedidoPorcentaje > 0"
							class="preview-orden-compra-totales-row"
						>
							<span>Dto. general pedido ({{ formatPorcentaje(previewOrdenCompraDescuentoPedidoPorcentaje) }})</span>
							<strong>-{{ formatImporteMoneda(previewOrdenCompraDescuentoPedidoImporte) }}</strong>
						</div>
						<div
							v-if="previewOrdenCompraPortesImporte > 0"
							class="preview-orden-compra-totales-row"
						>
							<span>Portes</span>
							<strong>{{ formatImporteMoneda(previewOrdenCompraPortesImporte) }}</strong>
						</div>
						<div class="preview-orden-compra-totales-row preview-orden-compra-totales-row--total">
							<span>Total</span>
							<strong>{{ formatImporteMoneda(previewOrdenCompraTotal) }}</strong>
						</div>
					</div>
					<p v-else class="preview-oferta-vacio">
						No hay líneas pendientes de compra para este proveedor.
					</p>
				</div>
			</div>
			<div v-else-if="modalProveedor.accion === 'oferta'" class="modal-lanzar-oferta">
				<el-select
					v-model="modalProveedor.proveedoresSeleccionadosOferta"
					placeholder="Seleccione uno o varios proveedores"
					filterable
					multiple
					collapse-tags
					style="width: 100%"
					:loading="loadingProveedores"
				>
					<el-option
						v-for="prov in proveedoresAsignados"
						:key="prov.id"
						:label="prov.nombre"
						:value="prov.id"
					/>
				</el-select>
				<div v-if="mostrarPreviewOfertaUnProveedor" class="preview-oferta-section">
					<p class="preview-oferta-titulo">Líneas incluidas en la oferta</p>
					<el-table
						v-if="lineasPreviewOferta.length"
						:data="lineasPreviewOferta"
						border
						size="small"
						max-height="320"
						style="width: 100%"
					>
						<el-table-column prop="posicion" label="Pos." width="56" align="center" />
						<el-table-column prop="referencia" label="Referencia" min-width="120" show-overflow-tooltip />
						<el-table-column prop="equipo" label="Equipo" min-width="220" show-overflow-tooltip />
						<el-table-column prop="cantidad" label="Cantidad" width="90" align="right" />
						<el-table-column prop="unidad" label="Unidad" width="110" align="center" />
					</el-table>
					<p v-else class="preview-oferta-vacio">
						No hay líneas pendientes de oferta para este proveedor.
					</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalProveedor.visible = false">Cancelar</el-button>
				<el-button
					v-if="modalProveedor.accion === 'ordenCompraPreview'"
					type="primary"
					:disabled="!puedeContinuarOrdenCompraPreview"
					@click="continuarOrdenCompraPaso2"
				>
					Continuar
				</el-button>
				<el-button
					v-else
					type="primary"
					:disabled="!puedeConfirmarModalProveedor"
					@click="confirmarProveedor"
				>
					Confirmar
				</el-button>
			</div>
		</el-dialog>

		<!-- Modal para ver ofertas de una línea específica -->
		<el-dialog
			title="Ofertas de la Línea"
			:visible.sync="modalOfertasLinea.visible"
			width="900px"
			:close-on-click-modal="false"
		>
			<div v-if="modalOfertasLinea.modo === 'linea'">
				<div style="margin-bottom: 15px;">
					<strong>Línea:</strong> {{ modalOfertasLinea.lineaSeleccionada ? `${modalOfertasLinea.lineaSeleccionada.posicion} - ${modalOfertasLinea.lineaSeleccionada.referencia}` : '' }}
				</div>
				<el-table :data="modalOfertasLinea.ofertas" border style="width: 100%">
					<el-table-column prop="fecha" label="Fecha Oferta" width="150">
						<template slot-scope="scope">
							{{ scope.row.fecha ? moment(scope.row.fecha).format('DD/MM/YYYY') : '-' }}
						</template>
					</el-table-column>
					<el-table-column prop="proveedor" label="Proveedor"></el-table-column>
					<el-table-column prop="precio" label="Precio" width="150">
						<template slot-scope="scope">
							<el-input-number
								v-model="scope.row.precio"
								:precision="2"
								:step="0.01"
								:min="0"
								size="small"
								style="width: 100%"
								@change="actualizarPrecioOferta(scope.row)"
							></el-input-number>
						</template>
					</el-table-column>
					<el-table-column label="Acciones" width="150">
						<template slot-scope="scope">
							<el-button
								type="primary"
								size="mini"
								@click="verOfertaCompleta(scope.row)"
							>
								Ver Oferta
							</el-button>
							<el-button
								type="success"
								size="mini"
								@click="abrirSubirDocumento(scope.row)"
							>
								Subir Documento
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else-if="modalOfertasLinea.modo === 'oferta'">
				<div style="margin-bottom: 15px;">
					<el-button type="text" @click="volverAOfertasLinea" icon="el-icon-back">
						Volver a Ofertas de la Línea
					</el-button>
					<el-button
						type="success"
						size="small"
						@click="abrirSubirDocumento(modalOfertasLinea.ofertaSeleccionada)"
						style="margin-left: 10px;"
					>
						<i class="el-icon-upload"></i> Subir Documento
					</el-button>
					<div style="margin-top: 10px;">
						<strong>Oferta:</strong> {{ modalOfertasLinea.ofertaSeleccionada ? `Fecha: ${moment(modalOfertasLinea.ofertaSeleccionada.fecha).format('DD/MM/YYYY')} - Proveedor: ${modalOfertasLinea.ofertaSeleccionada.proveedor}` : '' }}
					</div>
				</div>
				<el-table :data="modalOfertasLinea.lineasOferta" border style="width: 100%">
					<el-table-column prop="posicion" label="Posición" width="80"></el-table-column>
					<el-table-column prop="referencia" label="Referencia" width="150"></el-table-column>
					<el-table-column prop="equipo" label="Equipo"></el-table-column>
					<el-table-column prop="cantidad" label="Cantidad" width="100"></el-table-column>
					<el-table-column prop="unidad" label="Unidad" width="100"></el-table-column>
					<el-table-column prop="precio" label="Precio" width="150">
						<template slot-scope="scope">
							<el-input-number
								v-model="scope.row.precio"
								:precision="2"
								:step="0.01"
								:min="0"
								size="small"
								style="width: 100%"
								@change="actualizarPrecioOferta(scope.row)"
							></el-input-number>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalOfertasLinea.visible = false">Cerrar</el-button>
				<el-button type="primary" @click="guardarPreciosOfertas" v-if="modalOfertasLinea.modo === 'linea' || modalOfertasLinea.modo === 'oferta'">Guardar Precios</el-button>
			</div>
		</el-dialog>

		<!-- Modal para ver todas las ofertas de la propuesta -->
		<el-dialog
			title="Todas las Ofertas de la Propuesta"
			:visible.sync="modalTodasOfertas.visible"
			width="1200px"
			:close-on-click-modal="false"
		>
			<div v-if="modalTodasOfertas.modo === 'lista'">
				<el-table :data="modalTodasOfertas.ofertas" border style="width: 100%">
					<el-table-column prop="fecha" label="Fecha Oferta" width="150">
						<template slot-scope="scope">
							{{ scope.row.fecha ? moment(scope.row.fecha).format('DD/MM/YYYY') : '-' }}
						</template>
					</el-table-column>
					<el-table-column prop="proveedor" label="Proveedor"></el-table-column>
					<el-table-column label="Acciones" width="250">
						<template slot-scope="scope">
							<el-button
								type="primary"
								size="mini"
								@click="verOfertaDesdeLista(scope.row)"
							>
								Ver Oferta
							</el-button>
							<el-button
								type="success"
								size="mini"
								@click="abrirSubirDocumento(scope.row)"
							>
								Subir Documento
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else-if="modalTodasOfertas.modo === 'detalle'">
				<div style="margin-bottom: 15px;">
					<el-button type="text" @click="volverAListaOfertas" icon="el-icon-back">
						Volver a Lista de Ofertas
					</el-button>
					<el-button
						type="success"
						size="small"
						@click="abrirSubirDocumento(modalTodasOfertas.ofertaSeleccionada)"
						style="margin-left: 10px;"
					>
						<i class="el-icon-upload"></i> Subir Documento
					</el-button>
					<div style="margin-top: 10px;">
						<strong>Oferta:</strong> {{ modalTodasOfertas.ofertaSeleccionada ? `Fecha: ${moment(modalTodasOfertas.ofertaSeleccionada.fecha).format('DD/MM/YYYY')} - Proveedor: ${modalTodasOfertas.ofertaSeleccionada.proveedor}` : '' }}
					</div>
				</div>
				<el-table :data="modalTodasOfertas.lineasOferta" border style="width: 100%">
					<el-table-column prop="posicion" label="Posición" width="80"></el-table-column>
					<el-table-column prop="referencia" label="Referencia" width="150"></el-table-column>
					<el-table-column prop="equipo" label="Equipo"></el-table-column>
					<el-table-column prop="cantidad" label="Cantidad" width="100"></el-table-column>
					<el-table-column prop="unidad" label="Un. Medida" width="100"></el-table-column>
					<el-table-column prop="precio" label="Precio" width="150">
						<template slot-scope="scope">
							<el-input-number
								v-model="scope.row.precio"
								:precision="2"
								:step="0.01"
								:min="0"
								size="small"
								style="width: 100%"
								@change="actualizarPrecioOferta(scope.row)"
							></el-input-number>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalTodasOfertas.visible = false">Cerrar</el-button>
				<el-button type="primary" @click="guardarPreciosOfertas" v-if="modalTodasOfertas.modo === 'detalle'">Guardar Precios</el-button>
			</div>
		</el-dialog>

		<!-- Modal para añadir línea -->
		<el-dialog
			title="Añadir Nueva Línea"
			:visible.sync="modalAñadirLinea.visible"
			width="600px"
			:close-on-click-modal="false"
		>
			<el-form :model="modalAñadirLinea" label-width="180px" size="small">
				<el-form-item label="Sección:" v-if="propuesta.tipo === 'PUENTE'">
					<el-select
						v-model="modalAñadirLinea.seccionId"
						placeholder="Seleccione una sección"
						filterable
						style="width: 100%"
						@change="onSeccionChange"
					>
						<el-option
							v-for="seccion in secciones"
							:key="seccion.id"
							:label="seccion.nombre"
							:value="seccion.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item :label="propuesta.tipo === 'PUENTE' ? 'Grupo:' : 'Grupo:'">
					<el-select
						v-model="modalAñadirLinea.grupoId"
						placeholder="Seleccione un grupo"
						filterable
						style="width: 100%"
						:disabled="propuesta.tipo === 'PUENTE' && !modalAñadirLinea.seccionId"
					>
						<el-option
							v-for="grupo in gruposDisponibles"
							:key="grupo.id"
							:label="grupo.nombre"
							:value="grupo.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="Referencia:">
					<el-input
						v-model="modalAñadirLinea.referencia"
						placeholder="Referencia"
						maxlength="18"
						@input="onReferenciaModalChange"
					/>
				</el-form-item>
				<el-form-item label="Equipo:">
					<el-autocomplete
						v-model="modalAñadirLinea.equipo"
						:fetch-suggestions="(query, cb) => buscarArticulos(query, modalAñadirLinea.grupoId, cb)"
						placeholder="Buscar artículo o escribir..."
						value-key="DESCRIPCION"
						@select="seleccionarArticuloModal"
						style="width: 100%"
					>
						<template slot-scope="{ item }">
							<div>
								<div><strong>{{ item.CODIGO }}</strong> - {{ item.DESCRIPCION }}</div>
							</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="Cantidad:">
					<el-input-number
						v-model="modalAñadirLinea.cantidad"
						:min="0"
						:precision="0"
						style="width: 100%"
					/>
				</el-form-item>
				<el-form-item label="Unidad de Medida:">
					<el-input
						v-model="modalAñadirLinea.unidad"
						placeholder="Unidad de medida"
					/>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalAñadirLinea.visible = false">Cancelar</el-button>
				<el-button type="primary" @click="confirmarAñadirLinea()" :disabled="!validarDatosLinea">Guardar</el-button>
			</div>
		</el-dialog>

		<!-- Modal cambiar proveedor oferta en líneas seleccionadas -->
		<el-dialog
			title="Cambiar Proveedor Oferta"
			:visible.sync="modalCambiarProveedorOferta.visible"
			width="500px"
			:close-on-click-modal="false"
		>
			<p style="margin-top: 0; margin-bottom: 12px;">
				Se añadirán los proveedores seleccionados a {{ lineasSeleccionadas.length }} línea(s).
			</p>
			<el-form label-width="140px">
				<el-form-item label="Proveedores:" required>
					<el-select
						v-model="modalCambiarProveedorOferta.proveedorOfertaIds"
						placeholder="Proveedores Oferta"
						size="small"
						multiple
						filterable
						style="width: 100%"
						:loading="loadingProveedores"
					>
						<el-option
							v-for="prov in listaProveedores"
							:key="prov.id"
							:label="prov.nombre"
							:value="prov.id"
						/>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalCambiarProveedorOferta.visible = false" :disabled="modalCambiarProveedorOferta.guardando">Cancelar</el-button>
				<el-button
					type="primary"
					@click="confirmarCambiarProveedorOferta"
					:loading="modalCambiarProveedorOferta.guardando"
					:disabled="!modalCambiarProveedorOferta.proveedorOfertaIds.length"
				>
					Aceptar
				</el-button>
			</div>
		</el-dialog>

		<div class="propuesta-container" v-if="!modalInicial.visible && propuesta.id">
			<!-- Header de la propuesta -->
			<div class="propuesta-header">
				<div class="header-row">
					<div class="header-field">
						<label>BUQUE:</label>
						<el-input
							v-model="propuesta.buqueNombre"
							placeholder="Buque"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
					<div class="header-field">
						<label>{{ propuesta.tipo === 'PUENTE' ? 'CAPITAN:' : 'J.MAQUINAS:' }}</label>
						<el-input
							v-model="propuesta.jMaquinas"
							:placeholder="propuesta.tipo === 'PUENTE' ? 'Nombre del capitán' : 'Nombre del jefe de máquinas'"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
					<div class="header-field header-title">
						<h2>{{ propuesta.tipo === 'PUENTE' ? 'GESTIÓN PROPUESTA PUENTE - COMPRAS' : 'GESTIÓN PROPUESTA MAQUINAS - COMPRAS' }}</h2>
					</div>
					<div class="header-field">
						<label>FECHA CIERRE:</label>
						<el-input
							v-model="propuesta.fechaCierre"
							placeholder="Fecha Cierre"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
					<div class="header-field">
						<label>N° PROPUESTA PED.:</label>
						<el-input
							v-model="propuesta.numeroPropuesta"
							placeholder="Número de propuesta"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
				</div>
				<!-- Botones de acción -->
				<div class="propuesta-actions">
					<el-button type="text" @click="volverAlDashboard" icon="el-icon-back" class="link-volver-dashboard">
						Volver al Dashboard
					</el-button>
					<div class="propuesta-actions-buttons">
						<el-button type="primary" @click="guardarPropuesta">Guardar</el-button>
						<el-button
							type="primary"
							plain
							:disabled="!hayLineasSeleccionadas"
							@click="abrirModalCambiarProveedorOferta"
						>
							Cambiar Proveedor Oferta
						</el-button>
						<el-button type="success" @click="abrirModalAñadirLinea()">Añadir Línea</el-button>
						<el-button type="success" @click="abrirModalLanzarOferta">Lanzar Oferta</el-button>
						<el-button type="info" @click="abrirModalTodasOfertas">Ver Ofertas</el-button>
						<el-button type="warning" @click="abrirModalLanzarOrdenCompra">Lanzar Orden de Compra</el-button>
						<el-button type="danger" @click="abrirModalCerrarPropuesta">Cerrar Propuesta</el-button>
					</div>
				</div>
			</div>

			<!-- Tabla de propuesta -->
			<div class="propuesta-table-container">
				<!-- Encabezados de columna -->
				<div class="table-header">
					<div class="col-seleccion"></div>
					<div class="col-posicion">POSICION</div>
					<div class="col-referencia">REFERENCIA</div>
					<div class="col-equipo">EQUIPO (MODELO, SN,_)</div>
					<div class="col-cantidad">Cantidad</div>
					<div class="col-unidad">Un. Medida</div>
					<div class="col-precio">Precio</div>
					<div class="col-proveedor-oferta">Proveedor Oferta</div>
					<div class="col-proveedor">Proveedor Compra</div>
					<div class="col-estado">Estado</div>
					<div class="col-notas">Notas BARCO</div>
					<div class="col-acciones">Acciones</div>
				</div>

				<!-- Grupos y líneas para MAQUINAS -->
				<template v-if="propuesta.tipo === 'MAQUINAS'">
					<div
						v-for="grupo in gruposConLineas"
						:key="grupo.id"
						class="grupo-section"
						:class="`grupo-${grupo.codigo.toLowerCase()}`"
					>
						<!-- Título del grupo -->
						<div
							class="grupo-header"
							@click="toggleGrupo(grupo.id)"
							:class="{'grupo-collapsed': !grupo.visible}"
						>
							<i :class="grupo.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							<span class="grupo-nombre">{{ grupo.nombre }} ({{ contarLineasGrupo(grupo) }})</span>
						</div>
						<template v-if="grupo.visible">
							<div
								v-for="(linea, index) in grupo.lineasVisibles"
								:key="`${grupo.id}-${index}`"
								class="table-row"
								:class="{ 'table-row-seleccionada': isLineaSeleccionada(null, grupo.id, linea.posicion) }"
							>
								<div class="col-seleccion">
									<el-checkbox
										:value="isLineaSeleccionada(null, grupo.id, linea.posicion)"
										:disabled="linea.tieneOrdenCompra"
										@click.native="(e) => onCheckboxSeleccionClick(e, null, grupo.id, linea.posicion, linea)"
										@input="(val) => setSeleccionLinea(null, grupo.id, linea.posicion, linea, val)"
									/>
								</div>
								<div class="col-posicion">
									<div class="pos-indicadores">
										<el-tooltip
											v-if="mostrarIndicadorP(linea)"
											:content="getTooltipP(linea)"
											placement="top"
										>
											<span class="indicador-letra indicador-p">P</span>
										</el-tooltip>
										<el-tooltip
											v-if="mostrarIndicadorS(linea)"
											:content="getTooltipS(linea)"
											placement="top"
										>
											<span class="indicador-letra indicador-s">S</span>
										</el-tooltip>
										<el-tooltip
											v-if="linea.requiereRevisionInspector"
											:content="String(linea.ANOTACIONES_TECNICO != null ? linea.ANOTACIONES_TECNICO : '')"
											placement="top"
										>
											<span class="indicador-letra indicador-rc">RC</span>
										</el-tooltip>
									</div>
									<span class="posicion-text">{{ linea.posicion }}</span>
								</div>
								<div class="col-referencia">
									<el-input
										v-model="linea.referencia"
										placeholder="Referencia"
										size="small"
										:disabled="true"
										readonly
									/>
									<el-input
										v-model="linea.referenciaCompras"
										:placeholder="linea.esCatalogadoCompras ? 'Código artículo' : 'Referencia Compras'"
										size="small"
										maxlength="18"
										:disabled="linea.tieneOrdenCompra || linea.esCatalogadoCompras"
										@input="onReferenciaComprasChange(grupo.id, index)"
									/>
								</div>
								<div class="col-equipo">
									<el-tooltip
										:content="tooltipContenido"
										placement="top"
										:disabled="!tooltipActivo"
									>
										<span
											class="celda-equipo-tooltip"
											@mouseenter="evaluarTooltipOverflow($event, getEquipoConTalla(linea))"
											@mouseleave="ocultarTooltip"
										>
											<el-input
												:value="getEquipoConTalla(linea)"
												placeholder="Equipo (Modelo, SN,_)"
												size="small"
												:disabled="true"
												readonly
											/>
										</span>
									</el-tooltip>
									<div class="equipo-catalogo-row">
										<div class="equipo-input-wrap">
											<el-autocomplete
												v-if="grupo.tieneArticulos"
												v-model="linea.equipoCompras"
												:fetch-suggestions="(query, cb) => buscarArticulos(query, grupo.id, cb)"
												placeholder="Buscar artículo o escribir..."
												size="small"
												value-key="DESCRIPCION"
												:disabled="linea.tieneOrdenCompra"
												@select="(articulo) => seleccionarArticuloCompras(articulo, grupo.id, index)"
												@input="onEquipoComprasChange(grupo.id, index)"
												style="width: 100%"
											>
												<template slot-scope="{ item }">
													<div>
														<div><strong>{{ item.CODIGO }}</strong> - {{ item.DESCRIPCION }}</div>
													</div>
												</template>
											</el-autocomplete>
											<el-input
												v-else
												v-model="linea.equipoCompras"
												placeholder="Equipo Compras"
												size="small"
												:disabled="linea.tieneOrdenCompra"
												@input="onEquipoComprasChange(grupo.id, index)"
											/>
										</div>
										<div
											class="talla-inline"
											v-if="tieneTallajeCompras(linea)"
										>
											<el-select
												v-if="esTallajeCalzado(linea)"
												v-model="linea.tallaCompras"
												placeholder="Talla compras"
												filterable
												style="width: 100%"
												size="small"
												:disabled="linea.tieneOrdenCompra"
												@change="actualizarLinea(grupo.id, index)"
											>
												<el-option
													v-for="t in (linea.tallas_calzado || [])"
													:key="t.value || t.text || String(t)"
													:label="t.text || t.__title || t.label || String(t.value || '')"
													:value="t.value || t"
												/>
											</el-select>
											<el-select
												v-else-if="esTallajeRopa(linea)"
												v-model="linea.tallaCompras"
												placeholder="Talla compras"
												filterable
												style="width: 100%"
												size="small"
												:disabled="linea.tieneOrdenCompra"
												@change="actualizarLinea(grupo.id, index)"
											>
												<el-option
													v-for="t in (linea.tallas_ropa || [])"
													:key="t.value || t.text || String(t)"
													:label="t.text || t.__title || t.label || String(t.value || '')"
													:value="t.value || t"
												/>
											</el-select>
										</div>
									</div>
								</div>
								<div class="col-cantidad">
									<el-input
										v-model="linea.cantidad"
										placeholder="0"
										size="small"
										type="number"
										:min="0"
										:disabled="true"
										readonly
									/>
									<div
										v-if="getTextoConversionInformativa(linea)"
										class="conversion-info"
									>
										{{ getTextoConversionInformativa(linea) }}
									</div>
									<el-input
										v-model="linea.cantidadCompras"
										placeholder="Cantidad Compras"
										size="small"
										type="number"
										:min="1"
										:class="{ 'cantidad-compras-invalida': isCantidadComprasInvalida(linea) }"
										:disabled="linea.tieneOrdenCompra"
										:readonly="linea.tieneOrdenCompra"
										@input="onCantidadComprasChange(grupo.id, index, linea.cantidadCompras)"
										@blur="validarCantidadComprasEnLinea(linea)"
									/>
									<div
										v-if="getTextoConversionInformativa(linea)"
										class="conversion-info"
									>
										{{ getTextoConversionInformativa(linea) }}
									</div>
								</div>
								<div class="col-unidad">
									<el-input
										v-model="linea.unidad"
										placeholder="Unidad"
										size="small"
										:disabled="true"
										readonly
									/>
									<el-input
										v-if="!tieneConversionesUnidadCompra(linea)"
										v-model="linea.unidadMedidaCompras"
										placeholder="Unidad Compras"
										size="small"
										:disabled="linea.tieneOrdenCompra"
										:readonly="linea.tieneOrdenCompra"
										@input="onUnidadMedidaComprasChange(grupo.id, index, linea.unidadMedidaCompras)"
									/>
									<el-select
										v-else
										v-model="linea.unidadMedidaCompras"
										placeholder="Unidad Compras"
										size="small"
										filterable
										style="width: 100%"
										:disabled="linea.tieneOrdenCompra"
										@change="(val) => onUnidadMedidaComprasChange(grupo.id, index, val)"
									>
										<el-option
											v-for="opt in getOpcionesUnidadCompras(linea)"
											:key="opt.value"
											:label="opt.label"
											:value="opt.value"
										/>
									</el-select>
								</div>
								<div class="col-precio">
									<el-input
										v-model="linea.precio"
										placeholder="0.00"
										size="small"
										type="number"
										:min="0"
										step="0.01"
										:disabled="linea.tieneOrdenCompra"
										@input="actualizarLinea(grupo.id, index)"
									/>
									<el-input
										v-model="linea.descuento"
										placeholder="0"
										size="small"
										type="number"
										:min="0"
										step="0.01"
										:disabled="linea.tieneOrdenCompra"
										@input="actualizarLinea(grupo.id, index)"
									>
										<template slot="prepend">Dto:</template>
									</el-input>
								</div>
								<div class="col-proveedor-oferta">
									<el-select
										v-model="linea.proveedorOfertaIds"
										placeholder="Proveedores Oferta"
										size="small"
										multiple
										filterable
										style="width: 100%"
										:disabled="linea.tieneOrdenCompra"
										@change="actualizarLinea(grupo.id, index)"
									>
										<el-option
											v-for="prov in listaProveedores"
											:key="prov.id"
											:label="prov.nombre"
											:value="prov.id"
										/>
									</el-select>
								</div>
								<div class="col-proveedor">
									<el-select
										v-model="linea.proveedorId"
										placeholder="Seleccione proveedor"
										size="small"
										filterable
										clearable
										style="width: 100%"
										:disabled="linea.tieneOrdenCompra"
										@change="(val) => actualizarLineaConPrecio(grupo.id, index, val)"
									>
										<el-option
											v-for="prov in getProveedoresDisponiblesParaLinea(linea)"
											:key="prov.id"
											:label="prov.nombre"
											:value="prov.id"
										/>
									</el-select>
								</div>
								<div
									class="col-estado"
									:class="{
										'estado-no-aceptado': linea.estado === 3,
										'estado-stock-almacen': linea.estado === 4,
										'estado-aceptado': linea.estado === 2
									}"
								>
									<div class="estado-indicadores">
										<!-- Si tiene orden de compra, solo mostrar OC -->
										<el-tag v-if="linea.tieneOrdenCompra" type="warning" size="small">
											<i class="el-icon-document"></i> OC
										</el-tag>
										<!-- Si tiene oferta activa (aceptada), mostrar Oferta -->
										<el-tag v-if="mostrarEtiquetaOferta(linea)" type="success" size="small">
											<i class="el-icon-message"></i> Oferta
										</el-tag>
										<!-- Si no tiene nada, vacío -->
									</div>
									<div class="estado-compras" v-if="!linea.tieneOrdenCompra">
										<el-select
											v-model="linea.estado"
											placeholder="Estado compras"
											size="mini"
											style="width: 100%; margin-top: 4px;"
											@change="actualizarLinea(grupo.id, index)"
										>
											<el-option label="Pendiente" :value="1" />
											<el-option label="Aceptado" :value="2" />
											<el-option label="No Aceptado" :value="3" />
											<el-option label="Stock Almacen" :value="4" />
										</el-select>
									</div>
								</div>
								<div class="col-notas">
									<div class="nota-row">
										<small class="nota-label">NB</small>
                    <el-tooltip :content="tooltipContenido" placement="top" :disabled="!tooltipActivo">
                      <span class="celda-notas-tooltip" @mouseenter="evaluarTooltipOverflow($event, linea.notas)" @mouseleave="ocultarTooltip">
                      <el-input
                        v-model="linea.notas"
                        placeholder="Notas"
                        size="small"
                        :disabled="true"
                        readonly
                      />
                      </span>
                    </el-tooltip>
									</div>
									<div v-if="tieneTextoRelleno(linea.anotacionesTecnico)" class="nota-row">
                    <small class="nota-label">NI</small>
                    <el-tooltip :content="tooltipContenido" placement="top" :disabled="!tooltipActivo">
                      <span class="celda-notas-tooltip" @mouseenter="evaluarTooltipOverflow($event, linea.anotacionesTecnico)" @mouseleave="ocultarTooltip">
                      <el-input
                        :value="linea.anotacionesTecnico"
                        placeholder="Anotaciones técnico"
                        size="small"
                        :disabled="true"
                        readonly
                      />
                      </span>
                    </el-tooltip>
									</div>
									<div class="nota-row">
										<small class="nota-label">NC</small>
									<el-input
										v-model="linea.notasCompras"
										placeholder="Notas compras"
										size="small"
										@input="actualizarLinea(grupo.id, index)"
									/>
									</div>
								</div>
								<div class="col-acciones">
									<el-button
										v-if="linea.tieneDocumento && linea.idLineaPropuesta"
										type="info"
										size="mini"
										icon="el-icon-camera-solid"
										@click="descargarDocumentoLinea(linea)"
									/>
									<el-button
										type="primary"
										size="mini"
										@click="abrirModalOfertasLinea(linea)"
										:disabled="!linea.tieneOferta"
									>
										Ver Ofertas
									</el-button>
								</div>
							</div>
						</template>
					</div>
				</template>

				<!-- Secciones y grupos para PUENTE -->
				<template v-else-if="propuesta.tipo === 'PUENTE'">
					<div
						v-for="seccion in seccionesConLineas"
						:key="seccion.id"
						class="seccion-section"
						:class="`seccion-${seccion.nombre.toLowerCase()}`"
					>
						<div
							class="seccion-header"
							:class="[`seccion-${seccion.nombre.toLowerCase()}`]"
							@click="toggleSeccion(seccion.id)"
						>
							<i :class="seccion.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							<span>{{ seccion.nombre }} ({{ contarLineasSeccion(seccion) }})</span>
						</div>
						<template v-if="seccion.visible">
							<div
								v-for="grupo in seccion.grupos.filter(g => contarLineasGrupo(g) > 0)"
								:key="grupo.id"
								class="grupo-section"
								:class="`grupo-${grupo.codigo.toLowerCase()}`"
							>
								<!-- Título del grupo -->
								<div
									class="grupo-header"
									@click="toggleGrupoPuente(seccion.id, grupo.id)"
									:class="{'grupo-collapsed': !grupo.visible}"
								>
									<i :class="grupo.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
									<span class="grupo-nombre">{{ grupo.nombre }} ({{ contarLineasGrupo(grupo) }})</span>
								</div>
								<template v-if="grupo.visible">
									<div
										v-for="(linea, index) in grupo.lineasVisibles"
										:key="`${seccion.id}-${grupo.id}-${index}`"
										class="table-row"
										:class="{ 'table-row-seleccionada': isLineaSeleccionada(seccion.id, grupo.id, linea.posicion) }"
									>
										<div class="col-seleccion">
											<el-checkbox
												:value="isLineaSeleccionada(seccion.id, grupo.id, linea.posicion)"
												:disabled="linea.tieneOrdenCompra"
												@click.native="(e) => onCheckboxSeleccionClick(e, seccion.id, grupo.id, linea.posicion, linea)"
												@input="(val) => setSeleccionLinea(seccion.id, grupo.id, linea.posicion, linea, val)"
											/>
										</div>
										<div class="col-posicion">
											<div class="pos-indicadores">
												<el-tooltip
													v-if="mostrarIndicadorP(linea)"
													:content="getTooltipP(linea)"
													placement="top"
												>
													<span class="indicador-letra indicador-p">P</span>
												</el-tooltip>
												<el-tooltip
													v-if="mostrarIndicadorS(linea)"
													:content="getTooltipS(linea)"
													placement="top"
												>
													<span class="indicador-letra indicador-s">S</span>
												</el-tooltip>
												<el-tooltip
													v-if="linea.requiereRevisionInspector"
													:content="String(linea.ANOTACIONES_TECNICO != null ? linea.ANOTACIONES_TECNICO : '')"
													placement="top"
												>
													<span class="indicador-letra indicador-rc">RC</span>
												</el-tooltip>
											</div>
											<span class="posicion-text">{{ linea.posicion }}</span>
										</div>
										<div class="col-referencia">
											<el-input
												v-model="linea.referencia"
												placeholder="Referencia"
												size="small"
												:disabled="true"
												readonly
											/>
											<el-input
												v-model="linea.referenciaCompras"
												:placeholder="linea.esCatalogadoCompras ? 'Código artículo' : 'Referencia Compras'"
												size="small"
												maxlength="18"
												:disabled="linea.tieneOrdenCompra || linea.esCatalogadoCompras"
												@input="onReferenciaComprasChangePuente(seccion.id, grupo.id, index)"
											/>
										</div>
										<div class="col-equipo">
											<el-tooltip
												:content="tooltipContenido"
												placement="top"
												:disabled="!tooltipActivo"
											>
												<span
													class="celda-equipo-tooltip"
													@mouseenter="evaluarTooltipOverflow($event, getEquipoConTalla(linea))"
													@mouseleave="ocultarTooltip"
												>
													<el-input
														:value="getEquipoConTalla(linea)"
														placeholder="Equipo (Modelo, SN,_)"
														size="small"
														:disabled="true"
														readonly
													/>
												</span>
											</el-tooltip>
											<div class="equipo-catalogo-row">
												<div class="equipo-input-wrap">
													<el-autocomplete
														v-if="grupo.tieneArticulos"
														v-model="linea.equipoCompras"
														:fetch-suggestions="(query, cb) => buscarArticulos(query, grupo.id, cb)"
														placeholder="Buscar artículo o escribir..."
														size="small"
														value-key="DESCRIPCION"
														:disabled="linea.tieneOrdenCompra"
														@select="(articulo) => seleccionarArticuloComprasPuente(articulo, seccion.id, grupo.id, index)"
														@input="onEquipoComprasChangePuente(seccion.id, grupo.id, index)"
														style="width: 100%"
													>
														<template slot-scope="{ item }">
															<div>
																<div><strong>{{ item.CODIGO }}</strong> - {{ item.DESCRIPCION }}</div>
															</div>
														</template>
													</el-autocomplete>
													<el-input
														v-else
														v-model="linea.equipoCompras"
														placeholder="Equipo Compras"
														size="small"
														:disabled="linea.tieneOrdenCompra"
														@input="onEquipoComprasChangePuente(seccion.id, grupo.id, index)"
													/>
												</div>
												<div
													class="talla-inline"
													v-if="tieneTallajeCompras(linea)"
												>
													<el-select
														v-if="esTallajeCalzado(linea)"
														v-model="linea.tallaCompras"
														placeholder="Talla compras"
														filterable
														style="width: 100%"
														size="small"
														:disabled="linea.tieneOrdenCompra"
														@change="actualizarLineaPuente(seccion.id, grupo.id, index)"
													>
														<el-option
															v-for="t in (linea.tallas_calzado || [])"
															:key="t.value || t.text || String(t)"
															:label="t.text || t.__title || t.label || String(t.value || '')"
															:value="t.value || t"
														/>
													</el-select>
													<el-select
														v-else-if="esTallajeRopa(linea)"
														v-model="linea.tallaCompras"
														placeholder="Talla compras"
														filterable
														style="width: 100%"
														size="small"
														:disabled="linea.tieneOrdenCompra"
														@change="actualizarLineaPuente(seccion.id, grupo.id, index)"
													>
														<el-option
															v-for="t in (linea.tallas_ropa || [])"
															:key="t.value || t.text || String(t)"
															:label="t.text || t.__title || t.label || String(t.value || '')"
															:value="t.value || t"
														/>
													</el-select>
												</div>
											</div>
										</div>
										<div class="col-cantidad">
											<el-input
												v-model="linea.cantidad"
												placeholder="0"
												size="small"
												type="number"
												:min="0"
												:disabled="true"
												readonly
											/>
											<div
												v-if="getTextoConversionInformativa(linea)"
												class="conversion-info"
											>
												{{ getTextoConversionInformativa(linea) }}
											</div>
											<el-input
												v-model="linea.cantidadCompras"
												placeholder="Cantidad Compras"
												size="small"
												type="number"
												:min="1"
												:class="{ 'cantidad-compras-invalida': isCantidadComprasInvalida(linea) }"
												:disabled="linea.tieneOrdenCompra"
												:readonly="linea.tieneOrdenCompra"
												@input="onCantidadComprasChangePuente(seccion.id, grupo.id, index, linea.cantidadCompras)"
												@blur="validarCantidadComprasEnLinea(linea)"
											/>
											<div
												v-if="getTextoConversionInformativa(linea)"
												class="conversion-info"
											>
												{{ getTextoConversionInformativa(linea) }}
											</div>
										</div>
										<div class="col-unidad">
											<el-input
												v-model="linea.unidad"
												placeholder="Unidad"
												size="small"
												:disabled="true"
												readonly
											/>
											<el-input
												v-model="linea.unidadMedidaCompras"
												placeholder="Unidad Medida Compras"
												size="small"
												v-if="!tieneConversionesUnidadCompra(linea)"
												:disabled="linea.tieneOrdenCompra"
												:readonly="linea.tieneOrdenCompra"
												@input="onUnidadMedidaComprasChangePuente(seccion.id, grupo.id, index, linea.unidadMedidaCompras)"
										/>
										<el-select
											v-else
											v-model="linea.unidadMedidaCompras"
											placeholder="Unidad Medida Compras"
											size="small"
											filterable
											style="width: 100%"
											:disabled="linea.tieneOrdenCompra"
												@change="(val) => onUnidadMedidaComprasChangePuente(seccion.id, grupo.id, index, val)"
										>
											<el-option
												v-for="opt in getOpcionesUnidadCompras(linea)"
												:key="opt.value"
												:label="opt.label"
												:value="opt.value"
											/>
										</el-select>
										</div>
										<div class="col-precio">
											<el-input
												v-model="linea.precio"
												placeholder="0.00"
												size="small"
												type="number"
												:min="0"
												step="0.01"
												:disabled="linea.tieneOrdenCompra"
												@input="actualizarLineaPuente(seccion.id, grupo.id, index)"
											/>
											<el-input
												v-model="linea.descuento"
												placeholder="0"
												size="small"
												type="number"
												:min="0"
												step="0.01"
												:disabled="linea.tieneOrdenCompra"
												@input="actualizarLineaPuente(seccion.id, grupo.id, index)"
											>
												<template slot="prepend">Dto:</template>
											</el-input>
										</div>
										<div class="col-proveedor-oferta">
											<el-select
												v-model="linea.proveedorOfertaIds"
												placeholder="Proveedores Oferta"
												size="small"
												multiple
												filterable
												style="width: 100%"
												:disabled="linea.tieneOrdenCompra"
												@change="actualizarLineaPuente(seccion.id, grupo.id, index)"
											>
											<el-option-group
												v-if="getProveedoresAlternativosParaGrupoPuente(grupo.id).length"
												label="Alternativos"
											>
												<el-option
													v-for="prov in getProveedoresAlternativosParaGrupoPuente(grupo.id)"
													:key="prov.id"
													:label="prov.nombre"
													:value="prov.id"
												/>
											</el-option-group>
											<el-option-group
												label="Otros"
											>
												<el-option
													v-for="prov in getProveedoresOtrosParaGrupoPuente(grupo.id)"
													:key="prov.id"
													:label="prov.nombre"
													:value="prov.id"
												/>
											</el-option-group>
											</el-select>
										</div>
										<div class="col-proveedor">
											<el-select
												v-model="linea.proveedorId"
												placeholder="Seleccione proveedor"
												size="small"
												filterable
												clearable
												style="width: 100%"
												:disabled="linea.tieneOrdenCompra"
												@change="(val) => actualizarLineaPuenteConPrecio(seccion.id, grupo.id, index, val)"
											>
												<el-option
													v-for="prov in getProveedoresDisponiblesParaLinea(linea)"
													:key="prov.id"
													:label="prov.nombre"
													:value="prov.id"
												/>
											</el-select>
										</div>
										<div
											class="col-estado"
											:class="{
												'estado-no-aceptado': linea.estado === 3,
												'estado-stock-almacen': linea.estado === 4,
												'estado-aceptado': linea.estado === 2
											}"
										>
											<div class="estado-indicadores">
												<!-- Si tiene orden de compra, solo mostrar OC -->
												<el-tag v-if="linea.tieneOrdenCompra" type="warning" size="small">
													<i class="el-icon-document"></i> Comprado
												</el-tag>
												<!-- Si tiene oferta activa (aceptada), mostrar Oferta -->
												<el-tag v-if="mostrarEtiquetaOferta(linea)" type="success" size="small">
													<i class="el-icon-message"></i> Oferta
												</el-tag>
												<!-- Si no tiene nada, vacío -->
											</div>
											<div class="estado-compras" v-if="!linea.tieneOrdenCompra">
												<el-select
													v-model="linea.estado"
													placeholder="Estado compras"
													size="mini"
													style="width: 100%; margin-top: 4px;"
													@change="actualizarLineaPuente(seccion.id, grupo.id, index)"
												>
											<el-option label="Pendiente" :value="1" />
											<el-option label="Aceptado" :value="2" />
											<el-option label="No Aceptado" :value="3" />
											<el-option label="Stock Almacen" :value="4" />
												</el-select>
											</div>
										</div>
										<div class="col-notas">
											<div class="nota-row">
												<small class="nota-label">NB</small>
                        <el-tooltip :content="tooltipContenido" placement="top" :disabled="!tooltipActivo">
                          <span class="celda-notas-tooltip" @mouseenter="evaluarTooltipOverflow($event, linea.notas)" @mouseleave="ocultarTooltip">
                          <el-input
                            v-model="linea.notas"
                            placeholder="Notas"
                            size="small"
                            :disabled="true"
                            readonly
                          />
                          </span>
                        </el-tooltip>
											</div>
											<div v-if="tieneTextoRelleno(linea.anotacionesTecnico)" class="nota-row">
												<small class="nota-label">NI</small>
                        <el-tooltip :content="tooltipContenido" placement="top" :disabled="!tooltipActivo">
                          <span class="celda-notas-tooltip" @mouseenter="evaluarTooltipOverflow($event, linea.anotacionesTecnico)" @mouseleave="ocultarTooltip">
                          <el-input
                            :value="linea.anotacionesTecnico"
                            placeholder="Anotaciones técnico"
                            size="small"
                            :disabled="true"
                            readonly
                          />
                          </span>
                        </el-tooltip>
											</div>
											<div class="nota-row">
												<small class="nota-label">NC</small>
											<el-input
												v-model="linea.notasCompras"
												placeholder="Notas compras"
												size="small"
												@input="actualizarLineaPuente(seccion.id, grupo.id, index)"
											/>
											</div>
										</div>
										<div class="col-acciones">
											<el-button
												v-if="linea.tieneDocumento && linea.idLineaPropuesta"
												type="info"
												size="mini"
												icon="el-icon-camera-solid"
												@click="descargarDocumentoLinea(linea)"
											/>
											<el-button
												type="primary"
												size="mini"
												@click="abrirModalOfertasLinea(linea)"
												:disabled="!linea.tieneOferta"
											>
												Ver Ofertas
											</el-button>
										</div>
									</div>
								</template>
							</div>
						</template>
					</div>
				</template>
			</div>
		</div>

		<!-- Modal para subir documento -->
		<el-dialog
			title="Subir Documento"
			:visible.sync="modalSubirDocumento.visible"
			width="500px"
		>
			<el-form label-width="120px">
				<el-form-item label="Documento:" required>
					<input
						ref="inputFileDocumento"
						type="file"
						style="display: none"
						@change="onFileSelected"
						accept="*/*"
					/>
					<el-button type="primary" @click="$refs.inputFileDocumento.click()">
						<i class="el-icon-upload"></i> Seleccionar Archivo
					</el-button>
					<span v-if="modalSubirDocumento.archivoSeleccionado" style="margin-left: 10px;">
						{{ modalSubirDocumento.archivoSeleccionado.name }}
					</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalSubirDocumento.visible = false">Cancelar</el-button>
				<el-button
					type="primary"
					@click="subirDocumento"
					:loading="modalSubirDocumento.subiendo"
					:disabled="!modalSubirDocumento.archivoSeleccionado"
				>
					Subir
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState } from 'vuex'
import { getUrl } from '@/helpers/api'

export default {
  name: 'GestionarPropuestasCompras',
  data () {
    return {
      modalInicial: {
        visible: true
      },
      modalProveedor: {
        visible: false,
        proveedorSeleccionado: null,
        proveedoresSeleccionadosOferta: [],
        accion: null // 'oferta', 'ordenCompraPreview' o 'ordenCompra'
      },
      opcionesOrdenCompra: {
        secciones_pedido: [],
        tipo_envio: [],
        condiciones_envio: [],
        condiciones_pedido: [],
        formas_pago: [],
        divisas: [],
        direcciones_entrega: []
      },
      loadingOpcionesOrdenCompra: false,
      formOrdenCompra: {
        idSeccionesPedido: null,
        idTipoEnvio: null,
        idCondicionesEnvio: null,
        plazoEntrega: null,
        idCondicionesPedido: null,
        idFormaPago: null,
        idDivisa: null,
        idDireccionEntrega: null,
        direccionEntregaTexto: '',
        motivoAceptacionOferta: '',
        descuentoGeneralPedido: null,
        portes: null
      },
      modalOfertasLinea: {
        visible: false,
        lineaSeleccionada: null,
        ofertas: [],
        ofertaSeleccionada: null,
        lineasOferta: [],
        modo: 'linea' // 'linea' o 'oferta'
      },
      modalTodasOfertas: {
        visible: false,
        ofertas: [],
        ofertaSeleccionada: null,
        lineasOferta: [],
        modo: 'lista' // 'lista' o 'detalle'
      },
      modalAñadirLinea: {
        visible: false,
        seccionId: null,
        grupoId: null,
        referencia: '',
        equipo: '',
        cantidad: 0,
        unidad: '',
        articuloSeleccionado: null
      },
      modalSubirDocumento: {
        visible: false,
        ofertaId: null,
        archivoSeleccionado: null,
        subiendo: false
      },
      modalCerrarPropuesta: {
        visible: false,
        mensaje: '',
        cerrando: false
      },
      modalCambiarProveedorOferta: {
        visible: false,
        proveedorOfertaIds: [],
        guardando: false
      },
      lineasSeleccionadas: [],
      ultimaLineaSeleccionadaKey: null,
      ignorarSiguienteInputSeleccion: false,
      tooltipActivo: false,
      tooltipContenido: '',
      propuesta: {
        id: null,
        buqueId: null,
        buqueNombre: '',
        jMaquinas: '',
        fecha: '',
        numeroPropuesta: '',
        tipo: 'MAQUINAS',
        estado: 3, // Estado de la propuesta (siempre 3 para compras)
        fechaCierre: ''
      },
      grupos: [],
      secciones: [],
      listaPropuestas: [],
      listaProveedores: [],
      loadingPropuestas: false,
      loadingProveedores: false,
      propuestaSeleccionada: null,
      loadingInicial: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.data
    }),
    moment () {
      return moment
    },
    gruposConLineas () {
      // Filtrar grupos que tengan al menos una línea
      return this.grupos.filter(grupo => this.contarLineasGrupo(grupo) > 0)
    },
    seccionesConLineas () {
      // Filtrar secciones que tengan al menos un grupo con líneas
      return this.secciones.filter(seccion => {
        return seccion.grupos.some(grupo => this.contarLineasGrupo(grupo) > 0)
      }).map(seccion => ({
        ...seccion,
        grupos: seccion.grupos.filter(grupo => this.contarLineasGrupo(grupo) > 0)
      }))
    },
    gruposDisponibles () {
      // Si es PUENTE y hay sección seleccionada, devolver grupos de esa sección
      if (this.propuesta.tipo === 'PUENTE' && this.modalAñadirLinea.seccionId) {
        const seccion = this.secciones.find(s => s.id === this.modalAñadirLinea.seccionId)
        return seccion ? seccion.grupos : []
      }
      // Si es MAQUINAS, devolver todos los grupos
      return this.grupos
    },
    hayLineasSeleccionadas () {
      return this.lineasSeleccionadas.length > 0
    },
    tituloModalProveedor () {
      if (this.modalProveedor.accion === 'oferta') return 'Seleccionar Proveedor'
      return 'Lanzar Orden de Compra'
    },
    anchoModalProveedor () {
      if (this.modalProveedor.accion === 'ordenCompraPreview') return '1040px'
      return this.modalProveedor.accion === 'ordenCompra' ? '580px' : '920px'
    },
    nombreProveedorSeleccionadoModal () {
      if (!this.modalProveedor.proveedorSeleccionado) return ''
      const id = Number(this.modalProveedor.proveedorSeleccionado)
      const prov = this.listaProveedores.find(p => Number(p.id) === id)
      || this.proveedoresAsignados.find(p => Number(p.id) === id)
      return prov ? prov.nombre : ''
    },
    puedeConfirmarModalProveedor () {
      if (this.modalProveedor.accion === 'oferta') {
        const ids = this.modalProveedor.proveedoresSeleccionadosOferta || []
        if (!ids.length) return false
        if (ids.length === 1) return this.lineasPreviewOferta.length > 0
        return true
      }
      if (!this.modalProveedor.proveedorSeleccionado) return false
      return true
    },
    mostrarPreviewOfertaUnProveedor () {
      return this.modalProveedor.accion === 'oferta'
      && Array.isArray(this.modalProveedor.proveedoresSeleccionadosOferta)
      && this.modalProveedor.proveedoresSeleccionadosOferta.length === 1
    },
    puedeContinuarOrdenCompraPreview () {
      if (this.modalProveedor.accion !== 'ordenCompraPreview') return false
      if (!this.modalProveedor.proveedorSeleccionado) return false
      return this.lineasPreviewOrdenCompra.length > 0
    },
    lineasPreviewOrdenCompra () {
      if (this.modalProveedor.accion !== 'ordenCompraPreview' || !this.modalProveedor.proveedorSeleccionado) {
        return []
      }
      const proveedorId = this.modalProveedor.proveedorSeleccionado
      const items = []
      const agregar = (linea) => {
        if (!this.lineaPerteneceAProveedorOrden(linea, proveedorId)) return
        const precio = this.parseCantidadDecimal(linea.precio) || 0
        const descuento = this.parseCantidadDecimal(linea.descuento) || 0
        items.push({
          posicion: linea.posicion,
          referencia: linea.referencia || '',
          equipo: this.getEquipoPreviewCompras(linea),
          cantidad: this.getCantidadPreviewOferta(linea),
          unidad: this.getUnidadPreviewOferta(linea),
          precio,
          descuento,
          importe: this.getImporteLineaOrdenCompra(linea)
        })
      }
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(agregar)
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(agregar)
        })
      }
      return items
    },
    previewOrdenCompraSubtotal () {
      return this.lineasPreviewOrdenCompra.reduce((suma, linea) => suma + (Number(linea.importe) || 0), 0)
    },
    previewOrdenCompraDescuentoPedidoPorcentaje () {
      return this.parseCantidadDecimal(this.formOrdenCompra.descuentoGeneralPedido) || 0
    },
    previewOrdenCompraDescuentoPedidoImporte () {
      const pct = this.previewOrdenCompraDescuentoPedidoPorcentaje
      if (pct <= 0) return 0
      return this.previewOrdenCompraSubtotal * (pct / 100)
    },
    previewOrdenCompraPortesImporte () {
      return this.parseCantidadDecimal(this.formOrdenCompra.portes) || 0
    },
    previewOrdenCompraTotal () {
      return this.previewOrdenCompraSubtotal - this.previewOrdenCompraDescuentoPedidoImporte + this.previewOrdenCompraPortesImporte
    },
    lineasPreviewOferta () {
      if (this.modalProveedor.accion !== 'oferta') return []
      const ids = this.modalProveedor.proveedoresSeleccionadosOferta || []
      if (ids.length !== 1) return []
      const proveedorId = ids[0]
      const items = []
      const agregar = (linea) => {
        if (!this.lineaPerteneceAProveedorOferta(linea, proveedorId)) return
        if (this.lineaTieneOfertaLanzadaParaProveedor(linea, proveedorId)) return
        items.push({
          posicion: linea.posicion,
          referencia: linea.referencia || '',
          equipo: this.getEquipoPreviewCompras(linea),
          cantidad: this.getCantidadPreviewOferta(linea),
          unidad: this.getUnidadPreviewOferta(linea)
        })
      }
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(agregar)
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(agregar)
        })
      }
      return items
    },
    validarDatosLinea () {
      // Validar que todos los campos requeridos estén completos
      if (!this.modalAñadirLinea.grupoId) return false
      if (!this.modalAñadirLinea.referencia || this.modalAñadirLinea.referencia.trim() === '') return false
      if (!this.modalAñadirLinea.equipo || this.modalAñadirLinea.equipo.trim() === '') return false
      if (!this.modalAñadirLinea.cantidad || this.modalAñadirLinea.cantidad <= 0) return false
      if (!this.modalAñadirLinea.unidad || this.modalAñadirLinea.unidad.trim() === '') return false
      return true
    },
    direccionEntregaTexto: {
      get () {
        const idDireccion = this.formOrdenCompra.idDireccionEntrega
        if (!idDireccion) return ''
        if (idDireccion === '__otros__') return this.formOrdenCompra.direccionEntregaTexto || ''
        if (!Array.isArray(this.opcionesOrdenCompra.direcciones_entrega)) return ''
        const sel = this.opcionesOrdenCompra.direcciones_entrega.find(d => String(d.id) === String(idDireccion))
        return sel && sel.direccion ? sel.direccion : ''
      },
      set (value) {
        if (this.formOrdenCompra.idDireccionEntrega === '__otros__') {
          this.formOrdenCompra.direccionEntregaTexto = value
        }
      }
    },
    esDireccionEntregaOtros () {
      return this.formOrdenCompra.idDireccionEntrega === '__otros__'
    },
    proveedoresAsignados () {
      const proveedoresIds = new Set()
      const usarProveedoresOferta = this.modalProveedor.accion === 'oferta'

      const agregarProveedorPendiente = (linea, proveedorId) => {
        if (!proveedorId) return
        if (usarProveedoresOferta) {
          if (!this.lineaPerteneceAProveedorOferta(linea, proveedorId)) return
          if (this.lineaTieneOfertaLanzadaParaProveedor(linea, proveedorId)) return
        } else if (!this.lineaPerteneceAProveedorOrden(linea, proveedorId)) {
          return
        }
        proveedoresIds.add(Number(proveedorId))
      }

      const procesarLinea = (linea) => {
        if (usarProveedoresOferta) {
          const ids = Array.isArray(linea.proveedorOfertaIds) ? linea.proveedorOfertaIds : []
          ids.forEach(id => agregarProveedorPendiente(linea, id))
        } else if (linea.proveedorId) {
          agregarProveedorPendiente(linea, linea.proveedorId)
        }
      }

      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(procesarLinea)
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(procesarLinea)
        })
      }

      return this.listaProveedores.filter(prov => proveedoresIds.has(Number(prov.id)))
    }
  },
  async created () {
    // Si viene con un ID en la ruta, cargar directamente esa propuesta
    if (this.$route.params.id) {
      this.loadingInicial = true
      await this.cargarProveedores()
      await this.cargarPropuestaSeleccionada(Number(this.$route.params.id))
      this.loadingInicial = false
    } else {
      // Si no viene con ID, mostrar el modal de selección
      await this.cargarPropuestas()
      await this.cargarProveedores()
      this.loadingInicial = false
    }
  },
  methods: {
    limitarReferencia (val) {
      const s = val != null ? String(val) : ''
      return s.length > 18 ? s.slice(0, 18) : s
    },
    onReferenciaModalChange () {
      this.modalAñadirLinea.referencia = this.limitarReferencia(this.modalAñadirLinea.referencia)
    },
    async cargarPropuestas () {
      try {
        this.loadingPropuestas = true
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        // El backend filtrará solo propuestas con estado = 3 (compras)
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/listarPropuestasGestionar`,
          { estado: 3 }
        )

        if (Array.isArray(response.data)) {
          this.listaPropuestas = response.data
        } else if (response.data && Array.isArray(response.data.data)) {
          this.listaPropuestas = response.data.data
        } else {
          this.listaPropuestas = []
        }

        if (this.listaPropuestas.length === 0) {
          this.$message.info('No hay propuestas disponibles para gestionar')
        }
      } catch (error) {
        console.error('Error al cargar propuestas:', error)
        this.$message.error('Error al cargar las propuestas')
        this.listaPropuestas = []
      } finally {
        this.loadingPropuestas = false
      }
    },
    async cargarProveedores () {
      try {
        this.loadingProveedores = true
        const endpoints = getUrl()
        if (!endpoints) {
          return
        }

        // TODO: Ajustar el endpoint según la estructura del backend
        const response = await axios.post(
          `${endpoints.backend}entidad/proveedores/buscador/listarProveedores`,
          {}
        )

        if (Array.isArray(response.data)) {
          this.listaProveedores = response.data
        } else if (response.data && Array.isArray(response.data.data)) {
          this.listaProveedores = response.data.data
        } else {
          this.listaProveedores = []
        }

        // Si hay líneas cargadas, actualizar los nombres de proveedores
        if (this.propuesta.id) {
          this.actualizarNombresProveedores()
        }
      } catch (error) {
        console.error('Error al cargar proveedores:', error)
        // No mostrar error al usuario, solo registrar en consola
        this.listaProveedores = []
      } finally {
        this.loadingProveedores = false
      }
    },
    async cargarPropuestaSeleccionada (propuestaId) {
      try {
        this.lineasSeleccionadas = []
        this.ultimaLineaSeleccionadaKey = null
        this.loadingPropuestas = true
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/obtenerPropuesta`,
          { id: propuestaId, tipo: 'compras' }
        )

        if (response.data && response.data.cabecera) {
          // Guardar el ID de la propuesta
          this.propuesta.id = response.data.id

          // Cargar datos de la cabecera
          this.propuesta.buqueId = response.data.cabecera.buqueId
          this.propuesta.buqueNombre = response.data.cabecera.buque
          this.propuesta.jMaquinas = response.data.cabecera.jefeMaquinas
          this.propuesta.fecha = response.data.cabecera.fecha
          this.propuesta.numeroPropuesta = response.data.cabecera.numeroPropuesta || response.data.codigo
          this.propuesta.tipo = response.data.cabecera.tipo || 'MAQUINAS',
          this.propuesta.fechaCierre = response.data.cabecera.fechaCierre

          // El estado siempre será 3 para compras
          this.propuesta.estado = 3

          // Cargar grupos/secciones según el tipo PRIMERO
          await this.inicializarGrupos()

          // Esperar un momento para asegurar que los grupos estén inicializados
          await this.$nextTick()

          // Asegurarse de que los proveedores estén cargados antes de cargar líneas
          if (this.listaProveedores.length === 0) {
            await this.cargarProveedores()
          }

          // Cargar líneas DESPUÉS de inicializar grupos
          if (response.data.lineas && Array.isArray(response.data.lineas)) {
            console.log('Líneas recibidas del backend:', response.data.lineas)
            this.cargarLineasDesdeBackend(response.data.lineas)
            // Actualizar nombres de proveedores después de cargar líneas
            await this.$nextTick()
            this.actualizarNombresProveedores()
          } else {
            console.warn('No se recibieron líneas del backend o no es un array')
          }

          this.modalInicial.visible = false
          this.$message.success('Propuesta cargada correctamente')
        } else {
          this.$message.error('Error al cargar la propuesta')
        }
      } catch (error) {
        console.error('Error al cargar propuesta:', error)
        this.$message.error('Error al cargar la propuesta seleccionada')
      } finally {
        this.loadingPropuestas = false
      }
    },
    async inicializarGrupos () {
      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/listarSecciones`,
          { tipo: this.propuesta.tipo }
        )

        // La respuesta puede venir como array directo o dentro de { success: true, data: [...] }
        let data = response.data
        if (data && data.data && Array.isArray(data.data)) {
          data = data.data
        } else if (!Array.isArray(data)) {
          console.error('Formato de respuesta inesperado:', response.data)
          this.$message.error('Error en el formato de respuesta del backend')
          return
        }

        if (Array.isArray(data)) {
          if (this.propuesta.tipo === 'PUENTE') {
            this.inicializarGruposPuente(data)
          } else {
            this.inicializarGruposMaquinas(data)
          }
        }
      } catch (error) {
        console.error('Error al cargar grupos desde el backend:', error)
        this.$message.error('Error al cargar los grupos. Por favor, intente nuevamente.')
      }
    },
    inicializarGruposMaquinas (gruposBackend) {
      if (!gruposBackend || !Array.isArray(gruposBackend) || gruposBackend.length === 0) {
        console.warn('No se recibieron grupos desde el backend para MAQUINAS')
        return
      }

      console.log('Inicializando grupos MAQUINAS:', gruposBackend)
      this.grupos = gruposBackend.map((grupo) => {
        return {
          id: grupo.id,
          codigo: grupo.codigo,
          nombre: grupo.nombre,
          color: grupo.color,
          tieneArticulos: grupo.tieneArticulos || false,
          lineas: [],
          lineasVisibles: [],
          visible: false // Se expandirán solo los que tengan líneas
        }
      })
      console.log('Grupos inicializados:', this.grupos)
      this.secciones = []
    },
    inicializarGruposPuente (seccionesBackend) {
      if (!seccionesBackend || !Array.isArray(seccionesBackend) || seccionesBackend.length === 0) {
        console.warn('No se recibieron secciones desde el backend para PUENTE')
        return
      }

      this.secciones = seccionesBackend.map((seccion) => {
        return {
          id: seccion.id,
          nombre: seccion.nombre,
          color: seccion.color,
          proveedores_asignados: Array.isArray(seccion.proveedores_asignados) ? seccion.proveedores_asignados : [],
          grupos: seccion.grupos ? seccion.grupos.map((grupo) => ({
            id: grupo.id,
            codigo: grupo.codigo,
            nombre: grupo.nombre,
            color: grupo.color,
            tieneArticulos: grupo.tieneArticulos || false,
            proveedores_asignados: Array.isArray(grupo.proveedores_asignados) ? grupo.proveedores_asignados : [],
            lineas: [],
            lineasVisibles: [],
            visible: false // Se expandirán solo los que tengan líneas
          })) : [],
          visible: false // Se expandirán solo las que tengan líneas
        }
      })
      this.grupos = []
    },
    cargarLineasDesdeBackend (lineasBackend) {
      console.log('Cargando líneas desde backend:', lineasBackend)
      console.log('Grupos disponibles:', this.grupos)
      console.log('Tipo de propuesta:', this.propuesta.tipo)

      if (!lineasBackend || !Array.isArray(lineasBackend) || lineasBackend.length === 0) {
        console.warn('No hay líneas para cargar')
        return
      }

      // Conjuntos para rastrear qué grupos y secciones tienen datos
      const gruposConDatos = new Set()
      const seccionesConDatos = new Set()

      // Mapear las líneas del backend a la estructura de grupos
      // Evitar duplicados en UI si por cualquier motivo el mismo id encaja en más de un grupo.
      const keysLineasAñadidas = new Set()
      lineasBackend.forEach(lineaBackend => {
        const keyLinea =
					lineaBackend && lineaBackend.id != null
					  ? String(lineaBackend.id)
					  : [
					    lineaBackend && lineaBackend.grupo ? String(lineaBackend.grupo) : '',
					    lineaBackend && lineaBackend.posicion != null ? String(lineaBackend.posicion) : ''
					  ].join('-')

        if (keysLineasAñadidas.has(keyLinea)) return

        if (this.propuesta.tipo === 'PUENTE') {
          // Para PUENTE, buscar en secciones
          // Flag para evitar añadir la línea múltiples veces
          let lineaAñadida = false

          // Si el backend envía información de sección, usarla para filtrar
          const seccionNombre = lineaBackend.seccion || lineaBackend.seccionNombre

          for (const seccion of this.secciones) {
            // Si hay información de sección del backend, solo procesar esa sección
            if (seccionNombre && seccion.nombre !== seccionNombre) {
              continue
            }

            for (const grupo of seccion.grupos) {
              if (grupo.codigo === lineaBackend.grupo) {
                const cantidadGestion = this.getCantidadGestion(lineaBackend)
                const estadoInspector = lineaBackend.ESTADO_INSPECCION || lineaBackend.estadoInspeccion || lineaBackend.estado_inspeccion || ''
                // Agregar línea al grupo
                const linea = {
                  id: lineaBackend.id || null,
                  idLineaPropuesta: lineaBackend.idLineaPropuesta || lineaBackend.id || null,
                  posicion: lineaBackend.posicion,
                  referencia: lineaBackend.referencia || '',
                  equipo: lineaBackend.equipo || '',
                  talla: lineaBackend.talla || lineaBackend.TALLA || '',
                  cantidad: cantidadGestion.cantidad || '',
                  cantidadSolicitada: cantidadGestion.cantidadSolicitada || '',
                  cantidadAprobada: cantidadGestion.cantidadAprobada || '',
                  unidad: lineaBackend.unidad || '',
                  unidadBase: lineaBackend.unidadBase || lineaBackend.UNIDAD_BASE || lineaBackend.UNIDAD || 'Uds',
                  articulo_conversion: Array.isArray(lineaBackend.articulo_conversion) ? lineaBackend.articulo_conversion : (Array.isArray(lineaBackend.ARTICULO_CONVERSION) ? lineaBackend.ARTICULO_CONVERSION : []),
                  cantidadCompras: lineaBackend.cantidadCompras || cantidadGestion.cantidad || '',
                  unidadMedidaCompras: lineaBackend.unidadMedidaCompras || '',
                  notas: lineaBackend.notas || '',
                  anotacionesTecnico: this.resolverAnotacionesTecnico(lineaBackend),
                  notasCompras: lineaBackend.notasCompras || lineaBackend.NOTAS_COMPRAS || '',
                  precio: lineaBackend.precio || '',
                  ...this.getCamposComprasExtraLinea(lineaBackend),
                  ...this.getCamposCatalogoLinea(lineaBackend),
                  proveedorOferta: lineaBackend.proveedorOferta || '',
                  proveedorOfertaIds: this.normalizarProveedorOfertaIds(lineaBackend.proveedorOfertaIds, lineaBackend.proveedorOfertaId),
                  proveedoresOfertaLanzados: this.normalizarProveedoresOfertaLanzados(lineaBackend.proveedoresOfertaLanzados),
                  proveedorId: lineaBackend.proveedorId ? Number(lineaBackend.proveedorId) : (typeof lineaBackend.proveedor === 'number' ? Number(lineaBackend.proveedor) : null),
                  proveedor: lineaBackend.proveedor && typeof lineaBackend.proveedor === 'string' ? lineaBackend.proveedor : '',
                  tieneOferta: lineaBackend.tieneOferta || false,
                  tieneOrdenCompra: lineaBackend.tieneOrdenCompra || false,
                  tieneDocumento: !!(lineaBackend.tieneDocumento || lineaBackend.documentoAsociado || lineaBackend.tiene_documento),
                  requiereRevisionInspector: this.esEstadoInspectorRC(estadoInspector),
                  ANOTACIONES_TECNICO: this.resolverAnotacionesTecnico(lineaBackend),
                  estado: (() => {
                    return this.resolverEstadoLineaCompras(lineaBackend)
                  })(),
                  stock_disponible:
										lineaBackend.stock_disponible !== undefined && lineaBackend.stock_disponible !== null
										  ? lineaBackend.stock_disponible
										  : null,
                  proveedores_asignados: Array.isArray(lineaBackend.proveedores_asignados) ? lineaBackend.proveedores_asignados : []
                }
                // Si hay conversiones pero unidadMedidaCompras viene vacía, inicializar con la base.
                if (linea.articulo_conversion && linea.articulo_conversion.length && (!linea.unidadMedidaCompras || linea.unidadMedidaCompras === '')) {
                  linea.unidadMedidaCompras = linea.unidadBase || 'Uds'
                  linea.unidad = linea.unidadMedidaCompras
                }
                keysLineasAñadidas.add(keyLinea)
                grupo.lineas.push(linea)
                grupo.lineasVisibles.push(linea)
                gruposConDatos.add(`${seccion.id}-${grupo.id}`)
                seccionesConDatos.add(seccion.id)
                lineaAñadida = true
                // Evitar que la misma línea se pinte en más de un grupo/sección
                // dentro del mismo callback (caso de secciones con mismo nombre).
                return

                // Si no hay información de sección del backend, solo añadir a la primera coincidencia
                if (!seccionNombre) {
                  break
                }
              }
            }

            // Si ya se añadió la línea y no hay información de sección, salir del bucle de secciones
            if (lineaAñadida && !seccionNombre) {
              break
            }
          }
        } else {
          // Para MAQUINAS, buscar en grupos
          const grupo = this.grupos.find(g => g.codigo === lineaBackend.grupo)
          if (grupo) {
            const cantidadGestion = this.getCantidadGestion(lineaBackend)
            const estadoInspector = lineaBackend.ESTADO_INSPECCION || lineaBackend.estadoInspeccion || lineaBackend.estado_inspeccion || ''
            const linea = {
              id: lineaBackend.id || null,
              idLineaPropuesta: lineaBackend.idLineaPropuesta || lineaBackend.id || null,
              posicion: lineaBackend.posicion,
              referencia: lineaBackend.referencia || '',
              equipo: lineaBackend.equipo || '',
              talla: lineaBackend.talla || lineaBackend.TALLA || '',
              cantidad: cantidadGestion.cantidad || '',
              cantidadSolicitada: cantidadGestion.cantidadSolicitada || '',
              cantidadAprobada: cantidadGestion.cantidadAprobada || '',
              unidad: lineaBackend.unidad || '',
              unidadBase: lineaBackend.unidadBase || lineaBackend.UNIDAD_BASE || lineaBackend.UNIDAD || 'Uds',
              articulo_conversion: Array.isArray(lineaBackend.articulo_conversion) ? lineaBackend.articulo_conversion : (Array.isArray(lineaBackend.ARTICULO_CONVERSION) ? lineaBackend.ARTICULO_CONVERSION : []),
              cantidadCompras: lineaBackend.cantidadCompras || cantidadGestion.cantidad || '',
              unidadMedidaCompras: lineaBackend.unidadMedidaCompras || '',
              notas: lineaBackend.notas || '',
              anotacionesTecnico: this.resolverAnotacionesTecnico(lineaBackend),
              notasCompras: lineaBackend.notasCompras || lineaBackend.NOTAS_COMPRAS || '',
              precio: lineaBackend.precio || '',
              ...this.getCamposComprasExtraLinea(lineaBackend),
              ...this.getCamposCatalogoLinea(lineaBackend),
              proveedorOferta: lineaBackend.proveedorOferta || '',
              proveedorOfertaIds: this.normalizarProveedorOfertaIds(lineaBackend.proveedorOfertaIds, lineaBackend.proveedorOfertaId),
              proveedoresOfertaLanzados: this.normalizarProveedoresOfertaLanzados(lineaBackend.proveedoresOfertaLanzados),
              proveedorId: lineaBackend.proveedorId ? Number(lineaBackend.proveedorId) : (typeof lineaBackend.proveedor === 'number' ? Number(lineaBackend.proveedor) : null),
              proveedor: lineaBackend.proveedor && typeof lineaBackend.proveedor === 'string' ? lineaBackend.proveedor : '',
              tieneOferta: lineaBackend.tieneOferta || false,
              tieneOrdenCompra: lineaBackend.tieneOrdenCompra || false,
              tieneDocumento: !!(lineaBackend.tieneDocumento || lineaBackend.documentoAsociado || lineaBackend.tiene_documento),
              requiereRevisionInspector: this.esEstadoInspectorRC(estadoInspector),
              ANOTACIONES_TECNICO: this.resolverAnotacionesTecnico(lineaBackend),
              estado: this.resolverEstadoLineaCompras(lineaBackend),
              stock_disponible:
								lineaBackend.stock_disponible !== undefined && lineaBackend.stock_disponible !== null
								  ? lineaBackend.stock_disponible
								  : null,
              proveedores_asignados: Array.isArray(lineaBackend.proveedores_asignados) ? lineaBackend.proveedores_asignados : []
            }
            // Si hay conversiones pero unidadMedidaCompras viene vacía, inicializar con la base.
            if (linea.articulo_conversion && linea.articulo_conversion.length && (!linea.unidadMedidaCompras || linea.unidadMedidaCompras === '')) {
              linea.unidadMedidaCompras = linea.unidadBase || 'Uds'
              linea.unidad = linea.unidadMedidaCompras
            }
            keysLineasAñadidas.add(keyLinea)
            grupo.lineas.push(linea)
            grupo.lineasVisibles.push(linea)
            gruposConDatos.add(grupo.id)
          }
        }
      })

      // Expandir solo grupos y secciones que tienen datos
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          if (seccionesConDatos.has(seccion.id)) {
            seccion.visible = true
          }
          seccion.grupos.forEach(grupo => {
            if (gruposConDatos.has(`${seccion.id}-${grupo.id}`)) {
              grupo.visible = true
            }
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          if (gruposConDatos.has(grupo.id)) {
            grupo.visible = true
          }
        })
      }
    },
    toggleGrupo (grupoId) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (grupo) {
        grupo.visible = !grupo.visible
      }
    },
    toggleGrupoPuente (seccionId, grupoId) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        const grupo = seccion.grupos.find(g => g.id === grupoId)
        if (grupo) {
          grupo.visible = !grupo.visible
        }
      }
    },
    toggleSeccion (seccionId) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        seccion.visible = !seccion.visible
      }
    },
    contarLineasGrupo (grupo) {
      return grupo.lineasVisibles ? grupo.lineasVisibles.length : 0
    },
    contarLineasSeccion (seccion) {
      let total = 0
      seccion.grupos.forEach(grupo => {
        total += this.contarLineasGrupo(grupo)
      })
      return total
    },
    // Normaliza proveedorOfertaIds desde backend: array, id único o vacío
    normalizarProveedorOfertaIds (proveedorOfertaIds, proveedorOfertaId) {
      if (Array.isArray(proveedorOfertaIds) && proveedorOfertaIds.length) {
        return proveedorOfertaIds.map(id => Number(id)).filter(n => !isNaN(n))
      }
      if (proveedorOfertaId != null && proveedorOfertaId !== '') {
        const n = Number(proveedorOfertaId)
        return isNaN(n) ? [] : [n]
      }
      return []
    },
    normalizarProveedoresOfertaLanzados (proveedoresOfertaLanzados) {
      if (!Array.isArray(proveedoresOfertaLanzados)) return []
      return proveedoresOfertaLanzados.map(id => Number(id)).filter(n => !isNaN(n))
    },
    normalizarEstadoLinea (estado) {
      const n = Number(estado)
      if (!isNaN(n) && n >= 1 && n <= 4) return n
      const s = String(estado || '').trim().toLowerCase()
      if (s === 'pendiente') return 1
      if (s === 'aceptado' || s === 'aprobado') return 2
      if (s === 'no aceptado' || s === 'rechazado') return 3
      if (s === 'stock almacen' || s === 'stock almacén') return 4
      return 1
    },
    resolverEstadoLineaCompras (lineaBackend) {
      const estadoNorm = this.normalizarEstadoLinea(lineaBackend && lineaBackend.estado)
      if (lineaBackend && lineaBackend.tieneOrdenCompra && estadoNorm !== 2) return 2
      return estadoNorm
    },
    mostrarEtiquetaOferta (linea) {
      if (!linea || linea.tieneOrdenCompra) return false
      return !!linea.tieneOferta && Number(linea.estado) === 2
    },
    esEstadoInspectorRC (estadoInspector) {
      const txt = String(estadoInspector || '').trim().toUpperCase()
      return txt === 'RC' || txt === 'REVISAR COMPRAS' || txt === 'REVISAR EN COMPRAS'
    },
    tieneTextoRelleno (valor) {
      return valor != null && String(valor).trim() !== ''
    },
    resolverAnotacionesTecnico (lineaBackend) {
      if (!lineaBackend) return ''
      if (lineaBackend.ANOTACIONES_TECNICO != null && String(lineaBackend.ANOTACIONES_TECNICO).trim() !== '') {
        return lineaBackend.ANOTACIONES_TECNICO
      }
      return lineaBackend.anotacionesTecnico || ''
    },
    getCamposComprasExtraLinea (lineaBackend) {
      if (!lineaBackend) {
        return {
          descuento: '',
          referenciaCompras: '',
          equipoCompras: '',
          tallaCompras: '',
          esCatalogadoCompras: false,
          idArticuloCompras: null,
          descripcionArticuloOriginalCompras: ''
        }
      }
      return {
        descuento: lineaBackend.descuento != null ? lineaBackend.descuento : '',
        referenciaCompras: lineaBackend.referenciaCompras || '',
        equipoCompras: lineaBackend.equipoCompras || '',
        tallaCompras: lineaBackend.tallaCompras || lineaBackend.TALLA_COMPRAS || '',
        esCatalogadoCompras: false,
        idArticuloCompras: null,
        descripcionArticuloOriginalCompras: ''
      }
    },
    getCamposCatalogoLinea (lineaBackend) {
      if (!lineaBackend) {
        return {
          tipoTallaje: '',
          tallas_calzado: [],
          tallas_ropa: [],
          idArticulo: null,
          esCatalogado: false
        }
      }
      const idArticulo = lineaBackend.idArticulo || lineaBackend.IDARTICULOS || null
      const tipoTallaje = lineaBackend.tipoTallaje || lineaBackend.TIPO_TALLAJE || lineaBackend.tipo_tallaje || ''
      return {
        tipoTallaje,
        tallas_calzado: Array.isArray(lineaBackend.tallas_calzado) ? lineaBackend.tallas_calzado : [],
        tallas_ropa: Array.isArray(lineaBackend.tallas_ropa) ? lineaBackend.tallas_ropa : [],
        idArticulo,
        esCatalogado: !!(lineaBackend.esCatalogado || idArticulo)
      }
    },
    tipoTallajeNormalizado (linea) {
      return ((linea && linea.tipoTallaje) || '').toString().toLowerCase()
    },
    esTallajeCalzado (linea) {
      return this.tipoTallajeNormalizado(linea) === 'calzado' && Array.isArray(linea && linea.tallas_calzado) && linea.tallas_calzado.length > 0
    },
    esTallajeRopa (linea) {
      return this.tipoTallajeNormalizado(linea) === 'ropa' && Array.isArray(linea && linea.tallas_ropa) && linea.tallas_ropa.length > 0
    },
    tieneTallajeCompras (linea) {
      return this.esTallajeCalzado(linea) || this.esTallajeRopa(linea)
    },
    getCantidadGestion (lineaBackend) {
      const cantidadAprobada = lineaBackend && (
        lineaBackend.cantidadAprobada !== undefined
          ? lineaBackend.cantidadAprobada
          : (lineaBackend.CANTIDAD_APROBADA !== undefined ? lineaBackend.CANTIDAD_APROBADA : null)
      )
      const cantidadSolicitada = lineaBackend && lineaBackend.cantidad !== undefined ? lineaBackend.cantidad : ''
      if (cantidadAprobada !== null && cantidadAprobada !== undefined && String(cantidadAprobada).trim() !== '') {
        return {
          cantidad: cantidadAprobada,
          cantidadAprobada,
          cantidadSolicitada
        }
      }
      return {
        cantidad: cantidadSolicitada,
        cantidadAprobada: '',
        cantidadSolicitada
      }
    },
    getEquipoConTalla (linea) {
      if (!linea) return ''
      const eq = linea.equipo || ''
      const talla = linea.talla || linea.TALLA || ''
      if (!talla) return eq
      return `${eq} - ${talla}`
    },
    getImporteLineaOrdenCompra (linea) {
      if (!linea) return 0
      const cantidad = this.parseCantidadDecimal(this.getCantidadPreviewOferta(linea)) || 0
      const precio = this.parseCantidadDecimal(linea.precio) || 0
      const dtoPct = Math.min(100, Math.max(0, this.parseCantidadDecimal(linea.descuento) || 0))
      const bruto = cantidad * precio
      return Math.max(0, bruto * (1 - dtoPct / 100))
    },
    formatImporteMoneda (valor) {
      const num = Number(valor)
      if (!Number.isFinite(num)) return '-'
      return `${num.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
    },
    formatPorcentaje (valor) {
      const num = Number(valor)
      if (!Number.isFinite(num)) return '0%'
      return `${num.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%`
    },
    getEquipoPreviewCompras (linea) {
      if (!linea) return ''
      const equipoCompras = (linea.equipoCompras || '').trim()
      if (equipoCompras) return equipoCompras
      return this.getEquipoConTalla(linea)
    },
    evaluarTooltipOverflow (event, texto) {
      const input = event.currentTarget ? event.currentTarget.querySelector('.el-input__inner') : null

      const txt = texto != null ? String(texto).trim() : ''

      if (!txt || !input) {
        this.ocultarTooltip()
        return
      }

      this.tooltipContenido = txt
      this.tooltipActivo = input.scrollWidth > input.clientWidth
    },
    ocultarTooltip () {
      this.tooltipActivo = false
      this.tooltipContenido = ''
    },
    getConversionSeleccionada (linea) {
      if (!linea || !Array.isArray(linea.articulo_conversion) || !linea.articulo_conversion.length) return null
      const unidadSel = (linea.unidad || '').toString().trim().toLowerCase()
      if (!unidadSel) return null
      const base = (linea.unidadBase || 'Uds').toString().trim().toLowerCase()
      if (unidadSel === base) return null
      return linea.articulo_conversion.find(c =>
        ((c && c.CONVERSION) || '').toString().trim().toLowerCase() === unidadSel
      ) || null
    },
    getTextoConversionInformativa (linea) {
      const conv = this.getConversionSeleccionada(linea)
      if (!conv) return ''
      const cantidad = Number((((linea && linea.cantidad) || '') + '').replace(',', '.'))
      const factor = Number((((conv && conv.CANTIDAD) || '') + '').replace(',', '.'))
      if (isNaN(cantidad) || isNaN(factor)) return ''
      const total = cantidad * factor
      const totalFmt = Number.isInteger(total) ? String(total) : total.toFixed(2).replace(/\.00$/, '')
      const base = (linea.unidadBase || 'Uds').toString().trim() || 'Uds'
      return `= ${totalFmt} ${base}`
    },
    parseNumero (v) {
      const s = ((v !== undefined && v !== null) ? v : '').toString().replace(',', '.').trim()
      if (!s) return NaN
      return Number(s)
    },
    getIndicadorP (linea) {
      // P: proveedor asignado NO está en los 3 proveedores alternativos del artículo.
      if (!linea) return false
      const proveedorId = linea.proveedorId !== undefined && linea.proveedorId !== null && linea.proveedorId !== ''
        ? Number(linea.proveedorId)
        : NaN
      if (isNaN(proveedorId)) return false
      const alt = Array.isArray(linea.proveedores_asignados) ? linea.proveedores_asignados : []
      if (!alt.length) return false
      return !alt.map(Number).filter(n => !isNaN(n)).includes(proveedorId)
    },
    getIndicadorS (linea) {
      // S: stock disponible < cantidad solicitada.
      if (!linea) return false
      if (linea.stock_disponible === null || linea.stock_disponible === undefined) return false
      const stock = this.parseNumero(linea.stock_disponible)
      if (isNaN(stock)) return false
      const cantidad = this.parseNumero(linea.cantidad)
      if (isNaN(cantidad)) return false
      return stock < cantidad
    },
    mostrarIndicadorP (linea) {
      return this.getIndicadorP(linea)
    },
    getTooltipP (linea) {
      const proveedorId = linea && linea.proveedorId !== undefined && linea.proveedorId !== null && linea.proveedorId !== ''
        ? Number(linea.proveedorId)
        : null
      const alt = Array.isArray(linea && linea.proveedores_asignados) ? linea.proveedores_asignados : []
      // Solo el significado; el ID puede resultar ruidoso.
      return 'P: proveedor asignado distinto de los alternativos del artículo'
    },
    mostrarIndicadorS (linea) {
      return this.getIndicadorS(linea)
    },
    getTooltipS (linea) {
      const stock = this.parseNumero(linea.stock_disponible)
      const cantidad = this.parseNumero(linea.cantidad)
      if (isNaN(stock) || isNaN(cantidad)) return 'S: stock insuficiente'
      return `S: stock disponible ${stock} unidades`
    },
    getProveedoresDisponiblesParaLinea (linea) {
      // Filtrar proveedores para mostrar solo los que están en proveedorOfertaIds
      if (!linea || !linea.proveedorOfertaIds || !Array.isArray(linea.proveedorOfertaIds) || linea.proveedorOfertaIds.length === 0) {
        return []
      }
      const idsOferta = linea.proveedorOfertaIds.map(id => Number(id))
      return this.listaProveedores.filter(prov => idsOferta.includes(Number(prov.id)))
    },
    getLineaSeleccionKey (seccionId, grupoId, posicion) {
      if (seccionId != null && seccionId !== '') {
        return `p_${seccionId}_${grupoId}_${posicion}`
      }
      return `m_${grupoId}_${posicion}`
    },
    isLineaSeleccionada (seccionId, grupoId, posicion) {
      return this.lineasSeleccionadas.includes(this.getLineaSeleccionKey(seccionId, grupoId, posicion))
    },
    obtenerLineasVisiblesOrdenadas () {
      const items = []
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          if (!seccion.visible) return
          seccion.grupos.forEach(grupo => {
            if (!grupo.visible || this.contarLineasGrupo(grupo) === 0) return
            grupo.lineasVisibles.forEach((linea, index) => {
              items.push({
                key: this.getLineaSeleccionKey(seccion.id, grupo.id, linea.posicion),
                seccionId: seccion.id,
                grupoId: grupo.id,
                posicion: linea.posicion,
                linea,
                index,
                selectable: !linea.tieneOrdenCompra
              })
            })
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          if (!grupo.visible || this.contarLineasGrupo(grupo) === 0) return
          grupo.lineasVisibles.forEach((linea, index) => {
            items.push({
              key: this.getLineaSeleccionKey(null, grupo.id, linea.posicion),
              seccionId: null,
              grupoId: grupo.id,
              posicion: linea.posicion,
              linea,
              index,
              selectable: !linea.tieneOrdenCompra
            })
          })
        })
      }
      return items
    },
    onCheckboxSeleccionClick (event, seccionId, grupoId, posicion, linea) {
      if (!linea || linea.tieneOrdenCompra) return
      if (!event || !event.shiftKey || !this.ultimaLineaSeleccionadaKey) return

      event.preventDefault()
      event.stopPropagation()

      const key = this.getLineaSeleccionKey(seccionId, grupoId, posicion)
      this.ignorarSiguienteInputSeleccion = true
      this.seleccionarRangoLineas(this.ultimaLineaSeleccionadaKey, key)
      this.ultimaLineaSeleccionadaKey = key
      this.$nextTick(() => {
        this.ignorarSiguienteInputSeleccion = false
      })
    },
    seleccionarRangoLineas (anchorKey, targetKey) {
      const ordenadas = this.obtenerLineasVisiblesOrdenadas()
      const idxA = ordenadas.findIndex(item => item.key === anchorKey)
      const idxB = ordenadas.findIndex(item => item.key === targetKey)
      if (idxA < 0 || idxB < 0) return

      const desde = Math.min(idxA, idxB)
      const hasta = Math.max(idxA, idxB)
      const nuevas = []

      for (let i = desde; i <= hasta; i++) {
        const item = ordenadas[i]
        if (item && item.selectable) {
          nuevas.push(item.key)
        }
      }

      this.lineasSeleccionadas = nuevas
    },
    setSeleccionLinea (seccionId, grupoId, posicion, linea, selected) {
      if (this.ignorarSiguienteInputSeleccion) return
      if (!linea || linea.tieneOrdenCompra) return
      const key = this.getLineaSeleccionKey(seccionId, grupoId, posicion)
      const idx = this.lineasSeleccionadas.indexOf(key)
      if (selected && idx < 0) {
        this.lineasSeleccionadas.push(key)
      } else if (!selected && idx >= 0) {
        this.lineasSeleccionadas.splice(idx, 1)
      }
      this.ultimaLineaSeleccionadaKey = key
    },
    obtenerLineasSeleccionadasDetalle () {
      const seleccionadas = []
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach((linea, index) => {
              if (linea.tieneOrdenCompra) return
              if (!this.isLineaSeleccionada(seccion.id, grupo.id, linea.posicion)) return
              seleccionadas.push({
                linea,
                seccionId: seccion.id,
                grupoId: grupo.id,
                index
              })
            })
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach((linea, index) => {
            if (linea.tieneOrdenCompra) return
            if (!this.isLineaSeleccionada(null, grupo.id, linea.posicion)) return
            seleccionadas.push({
              linea,
              seccionId: null,
              grupoId: grupo.id,
              index
            })
          })
        })
      }
      return seleccionadas
    },
    añadirProveedoresOfertaALinea (linea, nuevosIds) {
      if (!linea || !Array.isArray(nuevosIds) || !nuevosIds.length) return
      const actuales = Array.isArray(linea.proveedorOfertaIds)
        ? linea.proveedorOfertaIds.map(id => Number(id)).filter(n => !isNaN(n))
        : []
      const nuevos = nuevosIds.map(id => Number(id)).filter(n => !isNaN(n))
      const merged = [...new Set([...actuales, ...nuevos])]
      this.$set(linea, 'proveedorOfertaIds', merged)
    },
    abrirModalCambiarProveedorOferta () {
      if (!this.hayLineasSeleccionadas) return
      this.modalCambiarProveedorOferta.proveedorOfertaIds = []
      this.modalCambiarProveedorOferta.visible = true
    },
    async confirmarCambiarProveedorOferta () {
      const nuevosIds = this.modalCambiarProveedorOferta.proveedorOfertaIds
      if (!nuevosIds || !nuevosIds.length) {
        this.$message.warning('Seleccione al menos un proveedor de oferta')
        return
      }
      const seleccionadas = this.obtenerLineasSeleccionadasDetalle()
      if (!seleccionadas.length) {
        this.$message.warning('No hay líneas seleccionadas')
        return
      }
      this.modalCambiarProveedorOferta.guardando = true
      try {
        seleccionadas.forEach(({ linea, seccionId, grupoId, index }) => {
          this.añadirProveedoresOfertaALinea(linea, nuevosIds)
          if (seccionId != null) {
            this.actualizarLineaPuente(seccionId, grupoId, index)
          } else {
            this.actualizarLinea(grupoId, index)
          }
        })
        this.modalCambiarProveedorOferta.visible = false
        const guardadoOk = await this.guardarPropuesta(true)
        if (guardadoOk) {
          this.lineasSeleccionadas = []
          this.ultimaLineaSeleccionadaKey = null
        }
      } finally {
        this.modalCambiarProveedorOferta.guardando = false
      }
    },
    /**
		 * En listarSecciones, `proveedores_asignados` viene por grupo (mismo id que linea.seccionId del backend).
		 * El id de la sección padre (PUENTE/CUBIERTA) no coincide con ese grupo.
		 */
    buscarGrupoPuentePorId (grupoId) {
      const gid = Number(grupoId)
      if (isNaN(gid)) return null
      for (let i = 0; i < this.secciones.length; i++) {
        const seccion = this.secciones[i]
        const grupo = (seccion.grupos || []).find(g => Number(g.id) === gid)
        if (grupo) return { seccion, grupo }
      }
      return null
    },
    getIdsAlternativosParaGrupoPuente (grupoId) {
      const found = this.buscarGrupoPuentePorId(grupoId)
      if (!found) return []
      const delGrupo = Array.isArray(found.grupo.proveedores_asignados) ? found.grupo.proveedores_asignados : []
      if (delGrupo.length) {
        return delGrupo.map(id => Number(id)).filter(n => !isNaN(n))
      }
      const deSeccion = Array.isArray(found.seccion.proveedores_asignados) ? found.seccion.proveedores_asignados : []
      return deSeccion.map(id => Number(id)).filter(n => !isNaN(n))
    },
    getProveedoresAlternativosParaGrupoPuente (grupoId) {
      const altIds = this.getIdsAlternativosParaGrupoPuente(grupoId)
      if (!altIds.length) return []
      return altIds
        .map(id => this.listaProveedores.find(p => Number(p.id) === Number(id)))
        .filter(Boolean)
    },
    getProveedoresOtrosParaGrupoPuente (grupoId) {
      const altIds = this.getIdsAlternativosParaGrupoPuente(grupoId)
      if (!altIds.length) return this.listaProveedores
      const altSet = new Set(altIds.map(Number))
      return this.listaProveedores.filter(p => !altSet.has(Number(p.id)))
    },
    async actualizarLineaConPrecio (grupoId, index, proveedorId) {
      // Sincronizar con el array completo de líneas
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (grupo && grupo.lineasVisibles[index]) {
        const lineaVisible = grupo.lineasVisibles[index]
        const indiceEnLineas = grupo.lineas.findIndex(l => l.posicion === lineaVisible.posicion)
        if (indiceEnLineas !== -1) {
          grupo.lineas[indiceEnLineas] = { ...lineaVisible }
        }

        // Si se seleccionó un proveedor, buscar y cargar el precio de la oferta
        if (proveedorId && lineaVisible.id) {
          await this.cargarPrecioOfertaParaLinea(lineaVisible, proveedorId)
        }
      }
    },
    async actualizarLineaPuenteConPrecio (seccionId, grupoId, index, proveedorId) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        const grupo = seccion.grupos.find(g => g.id === grupoId)
        if (grupo && grupo.lineasVisibles[index]) {
          const lineaVisible = grupo.lineasVisibles[index]
          const indiceEnLineas = grupo.lineas.findIndex(l => l.posicion === lineaVisible.posicion)
          if (indiceEnLineas !== -1) {
            grupo.lineas[indiceEnLineas] = { ...lineaVisible }
          }

          // Si se seleccionó un proveedor, buscar y cargar el precio de la oferta
          if (proveedorId && lineaVisible.id) {
            await this.cargarPrecioOfertaParaLinea(lineaVisible, proveedorId)
          }
        }
      }
    },
    parseCantidadDecimal (valor) {
      const txt = String(valor != null ? valor : '').trim()
      if (!txt) return null
      const num = parseFloat(txt.replace(',', '.'))
      return Number.isFinite(num) ? num : null
    },
    esCantidadComprasValida (cantidad) {
      const txt = String(cantidad != null ? cantidad : '').trim()
      if (!txt || txt.endsWith(',')) return false
      const num = this.parseCantidadDecimal(cantidad)
      return num !== null && num > 0
    },
    isCantidadComprasInvalida (linea) {
      if (!linea || linea.tieneOrdenCompra) return false
      const txt = String(linea.cantidadCompras != null ? linea.cantidadCompras : '').trim()
      if (!txt) return false
      return !this.esCantidadComprasValida(linea.cantidadCompras)
    },
    lineaExcluidaDeOfertaYOrden (linea) {
      const estado = Number(linea && linea.estado)
      return estado === 3 || estado === 4
    },
    lineaPerteneceAProveedorOrden (linea, proveedorId) {
      if (!linea || linea.tieneOrdenCompra || this.lineaExcluidaDeOfertaYOrden(linea) || proveedorId == null || proveedorId === '') return false
      return Number(linea.proveedorId) === Number(proveedorId)
    },
    lineaPerteneceAProveedorOferta (linea, proveedorId) {
      if (!linea || linea.tieneOrdenCompra || this.lineaExcluidaDeOfertaYOrden(linea) || proveedorId == null || proveedorId === '') return false
      const ids = Array.isArray(linea.proveedorOfertaIds) ? linea.proveedorOfertaIds : []
      return ids.some(id => Number(id) === Number(proveedorId))
    },
    lineaTieneOfertaLanzadaParaProveedor (linea, proveedorId) {
      if (!linea || proveedorId == null || proveedorId === '') return false
      const ids = Array.isArray(linea.proveedoresOfertaLanzados) ? linea.proveedoresOfertaLanzados : []
      return ids.some(id => Number(id) === Number(proveedorId))
    },
    recopilarLineasParaLanzarOferta (proveedorId) {
      const lineas = []
      const agregar = (linea, grupoCodigo) => {
        if (!this.lineaPerteneceAProveedorOferta(linea, proveedorId)) return
        if (this.lineaTieneOfertaLanzadaParaProveedor(linea, proveedorId)) return
        lineas.push({
          id: linea.id || null,
          grupo: grupoCodigo,
          posicion: linea.posicion
        })
      }
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(linea => agregar(linea, grupo.codigo))
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(linea => agregar(linea, grupo.codigo))
        })
      }
      return lineas
    },
    recopilarLineasParaLanzarOfertaMultiples (proveedorIds) {
      const vistos = new Set()
      const lineas = []
			;(proveedorIds || []).forEach((proveedorId) => {
        this.recopilarLineasParaLanzarOferta(proveedorId).forEach((linea) => {
          const clave = [linea.grupo, linea.posicion, linea.id].join('|')
          if (vistos.has(clave)) return
          vistos.add(clave)
          lineas.push(linea)
        })
      })
      return lineas
    },
    recopilarLineasParaLanzarOrdenCompra (proveedorId) {
      const lineas = []
      const agregar = (linea, grupoCodigo) => {
        if (!this.lineaPerteneceAProveedorOrden(linea, proveedorId)) return
        lineas.push({
          id: linea.id || null,
          grupo: grupoCodigo,
          posicion: linea.posicion
        })
      }
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(linea => agregar(linea, grupo.codigo))
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(linea => agregar(linea, grupo.codigo))
        })
      }
      return lineas
    },
    campoLineaRelleno (valor) {
      return valor !== null && valor !== undefined && String(valor).trim() !== ''
    },
    getCantidadPreviewOferta (linea) {
      if (!linea) return ''
      if (this.campoLineaRelleno(linea.cantidadCompras)) return linea.cantidadCompras
      return linea.cantidad != null ? linea.cantidad : ''
    },
    getUnidadPreviewOferta (linea) {
      if (!linea) return ''
      if (this.campoLineaRelleno(linea.unidadMedidaCompras)) return linea.unidadMedidaCompras
      return linea.unidad || ''
    },
    forEachLineaProveedorOrden (proveedorId, callback) {
      if (typeof callback !== 'function') return
      const revisar = (linea) => {
        if (this.lineaPerteneceAProveedorOrden(linea, proveedorId)) {
          callback(linea)
        }
      }
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(revisar)
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(revisar)
        })
      }
    },
    lineaTieneDescuento (linea) {
      if (!linea) return false
      const txt = String(linea.descuento != null ? linea.descuento : '').trim()
      if (!txt) return false
      const num = this.parseCantidadDecimal(linea.descuento)
      return num !== null && num > 0
    },
    proveedorOrdenTieneLineasConDescuento (proveedorId) {
      let tiene = false
      this.forEachLineaProveedorOrden(proveedorId, (linea) => {
        if (this.lineaTieneDescuento(linea)) {
          tiene = true
        }
      })
      return tiene
    },
    validarCantidadesComprasParaProveedor (proveedorId) {
      const faltantes = []
      const revisar = (linea) => {
        if (!this.lineaPerteneceAProveedorOrden(linea, proveedorId)) return
        if (!this.esCantidadComprasValida(linea.cantidadCompras)) {
          faltantes.push(linea.posicion)
        }
      }

      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(revisar)
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(revisar)
        })
      }

      if (!faltantes.length) return true

      const posiciones = faltantes.slice(0, 8).join(', ')
      const sufijo = faltantes.length > 8 ? `… (+${faltantes.length - 8})` : ''
      this.$message.error(`No se puede lanzar la orden de compra de este proveedor: hay líneas con cantidad 0 o sin indicar. Posiciones: ${posiciones}${sufijo}`)
      return false
    },
    filtrarCantidadCompras (linea) {
      if (!linea || linea.tieneOrdenCompra) return
      if (linea.cantidadCompras === '' || linea.cantidadCompras === null || linea.cantidadCompras === undefined) return
      const num = this.parseCantidadDecimal(linea.cantidadCompras)
      if (num !== null && num <= 0) {
        this.$message.warning('La cantidad de compras debe ser superior a 0')
        linea.cantidadCompras = ''
        linea.cantidad = ''
      }
    },
    validarCantidadComprasEnLinea (linea) {
      if (!linea || linea.tieneOrdenCompra) return true
      if (!this.isCantidadComprasInvalida(linea)) return true
      const num = this.parseCantidadDecimal(linea.cantidadCompras)
      if (num !== null && num <= 0) {
        this.$message.warning('La cantidad de compras debe ser superior a 0')
        linea.cantidadCompras = ''
        linea.cantidad = ''
      }
      return false
    },
    onCantidadComprasChange (grupoId, index, val) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      const linea = grupo.lineasVisibles[index]
      // cantidadCompras representa la cantidad que el usuario edita en formato de compras.
      // Para cumplir el payload del backend (unidad/cantidad), sincronizamos con los campos que se envían.
      linea.cantidadCompras = val
      this.filtrarCantidadCompras(linea)
      linea.cantidad = linea.cantidadCompras
      this.actualizarLinea(grupoId, index)
    },
    onUnidadMedidaComprasChange (grupoId, index, val) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      const linea = grupo.lineasVisibles[index]
      linea.unidadMedidaCompras = val
      linea.unidad = val
      this.actualizarLinea(grupoId, index)
    },
    onCantidadComprasChangePuente (seccionId, grupoId, index, val) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (!seccion) return
      const grupo = seccion.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      const linea = grupo.lineasVisibles[index]
      linea.cantidadCompras = val
      this.filtrarCantidadCompras(linea)
      linea.cantidad = linea.cantidadCompras
      this.actualizarLineaPuente(seccionId, grupoId, index)
    },
    onUnidadMedidaComprasChangePuente (seccionId, grupoId, index, val) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (!seccion) return
      const grupo = seccion.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      const linea = grupo.lineasVisibles[index]
      linea.unidadMedidaCompras = val
      linea.unidad = val
      this.actualizarLineaPuente(seccionId, grupoId, index)
    },
    tieneConversionesUnidadCompra (linea) {
      return Array.isArray(linea && linea.articulo_conversion) && linea.articulo_conversion.length > 0
    },
    getUnidadBaseCompra (linea) {
      const base =
				((linea && (linea.unidadBase || linea.unidad)) || '').toString().trim() || 'Uds'
      return base
    },
    getOpcionesUnidadCompras (linea) {
      if (!this.tieneConversionesUnidadCompra(linea)) return []
      const base = this.getUnidadBaseCompra(linea)
      const opciones = [{ value: base, label: base }]
      const usados = new Set([base.toLowerCase()])

			;(Array.isArray(linea.articulo_conversion) ? linea.articulo_conversion : []).forEach(c => {
        const conv = ((c && c.CONVERSION) || '').toString().trim()
        if (!conv) return
        const k = conv.toLowerCase()
        if (usados.has(k)) return
        usados.add(k)
        opciones.push({ value: conv, label: conv })
      })

      return opciones
    },
    async cargarPrecioOfertaParaLinea (linea, proveedorId) {
      try {
        const endpoints = getUrl()
        if (!endpoints || !linea.id) {
          return
        }

        // Obtener las ofertas de esta línea
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/ofertasPorLinea`,
          { lineaId: linea.id, propuestaId: this.propuesta.id }
        )

        if (response.data) {
          let ofertas = []
          if (response.data.success && Array.isArray(response.data.data)) {
            ofertas = response.data.data
          } else if (Array.isArray(response.data)) {
            ofertas = response.data
          } else if (response.data.data && Array.isArray(response.data.data)) {
            ofertas = response.data.data
          }

          // Buscar la oferta del proveedor seleccionado
          const proveedorSeleccionado = this.listaProveedores.find(p => Number(p.id) === Number(proveedorId))
          const ofertaProveedor = ofertas.find(oferta => {
            // Comparar por ID del proveedor o por nombre
            return (oferta.proveedorId && Number(oferta.proveedorId) === Number(proveedorId)) ||
						       (oferta.proveedor && proveedorSeleccionado && oferta.proveedor === proveedorSeleccionado.nombre)
          })

          // Si se encontró una oferta, actualizar el precio
          if (ofertaProveedor && ofertaProveedor.precio) {
            linea.precio = ofertaProveedor.precio
            // Actualizar también en el array completo de líneas
            if (this.propuesta.tipo === 'PUENTE') {
              this.secciones.forEach(seccion => {
                seccion.grupos.forEach(grupo => {
                  const indice = grupo.lineas.findIndex(l => l.id === linea.id)
                  if (indice !== -1) {
                    grupo.lineas[indice].precio = ofertaProveedor.precio
                  }
                })
              })
            } else {
              this.grupos.forEach(grupo => {
                const indice = grupo.lineas.findIndex(l => l.id === linea.id)
                if (indice !== -1) {
                  grupo.lineas[indice].precio = ofertaProveedor.precio
                }
              })
            }
          }
        }
      } catch (error) {
        console.error('Error al cargar precio de oferta:', error)
        // No mostrar error al usuario, solo registrar en consola
      }
    },
    actualizarLinea (grupoId, index) {
      // Sincronizar con el array completo de líneas
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (grupo && grupo.lineasVisibles[index]) {
        const lineaVisible = grupo.lineasVisibles[index]
        const indiceEnLineas = grupo.lineas.findIndex(l => l.posicion === lineaVisible.posicion)
        if (indiceEnLineas !== -1) {
          grupo.lineas[indiceEnLineas] = { ...lineaVisible }
        }
      }
    },
    actualizarLineaPuente (seccionId, grupoId, index) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        const grupo = seccion.grupos.find(g => g.id === grupoId)
        if (grupo && grupo.lineasVisibles[index]) {
          const lineaVisible = grupo.lineasVisibles[index]
          const indiceEnLineas = grupo.lineas.findIndex(l => l.posicion === lineaVisible.posicion)
          if (indiceEnLineas !== -1) {
            grupo.lineas[indiceEnLineas] = { ...lineaVisible }
          }
        }
      }
    },
    async guardarPropuesta (mostrarMensaje = true) {
      try {
        // Recopilar todas las líneas con sus datos actualizados
        const lineas = []

        if (this.propuesta.tipo === 'PUENTE') {
          this.secciones.forEach(seccion => {
            seccion.grupos.forEach(grupo => {
              grupo.lineasVisibles.forEach(linea => {
                // Obtener el nombre del proveedor desde la lista
                const proveedorSeleccionado = this.listaProveedores.find(p => p.id === linea.proveedorId)
                lineas.push({
                  id: linea.id || null,
                  grupo: grupo.codigo,
                  grupoNombre: grupo.nombre,
                  seccion: seccion.nombre,
                  posicion: linea.posicion,
                  referencia: linea.referencia || '',
                  equipo: linea.equipo || '',
                  talla: linea.talla || linea.TALLA || '',
                  idArticulo: linea.idArticulo || null,
                  esCatalogado: !!linea.esCatalogado,
                  cantidad: linea.cantidad || 0,
                  unidad: linea.unidad || '',
                  notas: linea.notas || '',
                  notasCompras: linea.notasCompras || '',
                  precio: linea.precio || '',
                  descuento: linea.descuento != null ? linea.descuento : '',
                  referenciaCompras: linea.referenciaCompras || '',
                  equipoCompras: linea.equipoCompras || '',
                  tallaCompras: linea.tallaCompras || linea.TALLA_COMPRAS || '',
                  proveedorId: linea.proveedorId || null,
                  proveedor: proveedorSeleccionado ? proveedorSeleccionado.nombre : '',
                  proveedorOfertaIds: Array.isArray(linea.proveedorOfertaIds) ? linea.proveedorOfertaIds : [],
                  estado: linea.estado !== undefined && linea.estado !== null ? linea.estado : 1
                })
              })
            })
          })
        } else {
          this.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(linea => {
              // Obtener el nombre del proveedor desde la lista
              const proveedorSeleccionado = this.listaProveedores.find(p => p.id === linea.proveedorId)
              lineas.push({
                id: linea.id || null,
                grupo: grupo.codigo,
                grupoNombre: grupo.nombre,
                posicion: linea.posicion,
                referencia: linea.referencia || '',
                equipo: linea.equipo || '',
                talla: linea.talla || linea.TALLA || '',
                idArticulo: linea.idArticulo || null,
                esCatalogado: !!linea.esCatalogado,
                cantidad: linea.cantidad || 0,
                unidad: linea.unidad || '',
                notas: linea.notas || '',
                notasCompras: linea.notasCompras || '',
                precio: linea.precio || '',
                descuento: linea.descuento != null ? linea.descuento : '',
                referenciaCompras: linea.referenciaCompras || '',
                equipoCompras: linea.equipoCompras || '',
                tallaCompras: linea.tallaCompras || linea.TALLA_COMPRAS || '',
                proveedorId: linea.proveedorId || null,
                proveedor: proveedorSeleccionado ? proveedorSeleccionado.nombre : '',
                proveedorOfertaIds: Array.isArray(linea.proveedorOfertaIds) ? linea.proveedorOfertaIds : [],
                estado: linea.estado !== undefined && linea.estado !== null ? linea.estado : 1
              })
            })
          })
        }

        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return false
        }

        // Llamar al backend para guardar los datos de las líneas
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/guardarGestionPropuesta`,
          {
            id: this.propuesta.id,
            lineas: lineas
          }
        )

        if (response.data && !response.data.error) {
          // Backend puede devolver lineas actualizadas con cantidad/unidad y su cálculo de compras
          const lineasRet =
						(Array.isArray(response.data.lineas) ? response.data.lineas : null) ||
						(response.data.data && Array.isArray(response.data.data.lineas) ? response.data.data.lineas : null)
          if (lineasRet) {
            this.actualizarCamposLineasDesdeBackend(lineasRet)
          }
          if (mostrarMensaje) this.$message.success('Propuesta guardada correctamente')
          return true
        } else {
          const mensaje = (response.data && response.data.mensaje) ? response.data.mensaje : 'Error al guardar la propuesta'
          this.$message.error(mensaje)
          return false
        }
      } catch (error) {
        console.error('Error al guardar propuesta:', error)
        this.$message.error('Error al guardar la propuesta. Por favor, intente nuevamente.')
        return false
      }
    },
    abrirModalLanzarOferta () {
      this.modalProveedor.accion = 'oferta'
      this.modalProveedor.proveedorSeleccionado = null
      this.modalProveedor.proveedoresSeleccionadosOferta = []
      this.modalProveedor.visible = true
    },
    abrirModalLanzarOrdenCompra () {
      this.modalProveedor.accion = 'ordenCompraPreview'
      this.modalProveedor.proveedorSeleccionado = null
      this.formOrdenCompra.descuentoGeneralPedido = null
      this.formOrdenCompra.portes = null
      this.modalProveedor.visible = true
    },
    continuarOrdenCompraPaso2 () {
      if (!this.puedeContinuarOrdenCompraPreview) return
      const descuentoGeneralPedido = this.formOrdenCompra.descuentoGeneralPedido
      const portes = this.formOrdenCompra.portes
      this.modalProveedor.accion = 'ordenCompra'
      this.formOrdenCompra = {
        idSeccionesPedido: null,
        idTipoEnvio: null,
        idCondicionesEnvio: null,
        plazoEntrega: null,
        idCondicionesPedido: null,
        idFormaPago: null,
        idDivisa: null,
        idDireccionEntrega: null,
        direccionEntregaTexto: '',
        motivoAceptacionOferta: '',
        descuentoGeneralPedido,
        portes
      }
      this.cargarOpcionesOrdenCompra()
    },
    onDireccionEntregaChange (value) {
      // Solo conservar texto manual cuando la opción es "Otros"
      if (value !== '__otros__') this.formOrdenCompra.direccionEntregaTexto = ''
    },
    resolverDefaultOpcionOrdenCompra (valor, lista) {
      if (valor == null || valor === '') return null
      const id = Number(valor)
      if (isNaN(id)) return null
      if (Array.isArray(lista) && lista.length && !lista.some(item => Number(item.id) === id)) {
        return null
      }
      return id
    },
    aplicarDefaultsOrdenCompra (defaults) {
      if (!defaults || typeof defaults !== 'object') return
      const opts = this.opcionesOrdenCompra
      this.formOrdenCompra.idFormaPago = this.resolverDefaultOpcionOrdenCompra(defaults.IDFORMAS_PAGO, opts.formas_pago)
      this.formOrdenCompra.idTipoEnvio = this.resolverDefaultOpcionOrdenCompra(defaults.IDTIPO_ENVIO, opts.tipo_envio)
      this.formOrdenCompra.idCondicionesEnvio = this.resolverDefaultOpcionOrdenCompra(defaults.IDCONDICIONES_ENVIO, opts.condiciones_envio)
      this.formOrdenCompra.idSeccionesPedido = this.resolverDefaultOpcionOrdenCompra(defaults.IDSECCIONES_PEDIDO, opts.secciones_pedido)
      this.formOrdenCompra.idDivisa = this.resolverDefaultOpcionOrdenCompra(defaults.IDDIVISAS, opts.divisas)
    },
    async cargarOpcionesOrdenCompra () {
      const endpoints = getUrl()
      if (!endpoints) return
      const proveedorId = this.modalProveedor.proveedorSeleccionado
      const propuestaId = this.propuesta && this.propuesta.id
      if (!propuestaId || proveedorId == null || proveedorId === '') {
        this.$message.warning('Faltan datos de propuesta o proveedor para cargar el formulario de orden de compra')
        return
      }
      this.loadingOpcionesOrdenCompra = true
      try {
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/opcionesFormularioOrdenCompra`,
          {
            id: propuestaId,
            proveedorId
          }
        )
        const data = response.data && response.data.data ? response.data.data : response.data
        if (data && typeof data === 'object') {
          this.opcionesOrdenCompra = {
            secciones_pedido: Array.isArray(data.secciones_pedido) ? data.secciones_pedido : [],
            tipo_envio: Array.isArray(data.tipo_envio) ? data.tipo_envio : [],
            condiciones_envio: Array.isArray(data.condiciones_envio) ? data.condiciones_envio : [],
            condiciones_pedido: Array.isArray(data.condiciones_pedido) ? data.condiciones_pedido : [],
            formas_pago: Array.isArray(data.formas_pago) ? data.formas_pago : [],
            divisas: Array.isArray(data.divisas) ? data.divisas : [],
            direcciones_entrega: Array.isArray(data.direcciones_entrega) ? data.direcciones_entrega : []
          }
          this.aplicarDefaultsOrdenCompra(data.defaults)
        }
      } catch (error) {
        console.error('Error al cargar opciones del formulario orden de compra:', error)
        this.$message.error('Error al cargar opciones del formulario')
      } finally {
        this.loadingOpcionesOrdenCompra = false
      }
    },
    abrirModalAñadirLinea () {
      try {
        console.log('Abrir modal añadir línea', this.modalAñadirLinea)
        // Usar $set para asegurar reactividad
        this.$set(this.modalAñadirLinea, 'visible', true)
        this.$set(this.modalAñadirLinea, 'seccionId', null)
        this.$set(this.modalAñadirLinea, 'grupoId', null)
        this.$set(this.modalAñadirLinea, 'referencia', '')
        this.$set(this.modalAñadirLinea, 'equipo', '')
        this.$set(this.modalAñadirLinea, 'cantidad', 0)
        this.$set(this.modalAñadirLinea, 'unidad', '')
        this.$set(this.modalAñadirLinea, 'articuloSeleccionado', null)
        console.log('Modal visible:', this.modalAñadirLinea.visible)
      } catch (error) {
        console.error('Error al abrir modal:', error)
        this.$message.error('Error al abrir el modal de añadir línea')
      }
    },
    onSeccionChange () {
      // Resetear grupoId cuando cambia la sección
      this.modalAñadirLinea.grupoId = null
    },
    async buscarArticulos (query, idGrupo, callback) {
      try {
        const endpoints = getUrl()
        if (!endpoints) {
          callback([])
          return
        }

        if (!idGrupo) {
          callback([])
          return
        }

        const payload = {
          id: idGrupo
        }

        if (query && query.trim() !== '') {
          payload.descripcion = query.trim()
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/articulos/buscador/listarArticulosSeccion`,
          payload
        )

        const { articulos, tallasCalzado, tallasRopa } = this.parsearRespuestaArticulosSeccion(response.data)

        const resultados = articulos.map(articulo => ({
          ...articulo,
          __tallas_calzado: tallasCalzado,
          __tallas_ropa: tallasRopa,
          value: articulo.DESCRIPCION || ''
        }))

        callback(resultados)
      } catch (error) {
        console.error('Error al buscar artículos:', error)
        callback([])
      }
    },
    parsearRespuestaArticulosSeccion (data) {
      let articulos = []
      let tallasCalzado = []
      let tallasRopa = []

      if (Array.isArray(data)) {
        articulos = data
      } else if (data && Array.isArray(data.data)) {
        articulos = data.data
      } else if (data && Array.isArray(data.articulos)) {
        articulos = data.articulos
        tallasCalzado = Array.isArray(data.tallas_calzado) ? data.tallas_calzado : []
        tallasRopa = Array.isArray(data.tallas_ropa) ? data.tallas_ropa : []
      } else if (data && data.data && Array.isArray(data.data.articulos)) {
        articulos = data.data.articulos
        tallasCalzado = Array.isArray(data.data.tallas_calzado) ? data.data.tallas_calzado : []
        tallasRopa = Array.isArray(data.data.tallas_ropa) ? data.data.tallas_ropa : []
      } else if (data && data.success && Array.isArray(data.data)) {
        articulos = data.data
      }

      return { articulos, tallasCalzado, tallasRopa }
    },
    getUnidadBaseArticulo (articulo) {
      const base = ((articulo && articulo.UNIDAD) || '').toString().trim()
      return base || 'Uds'
    },
    getOpcionesUnidadDesdeArticulo (articulo, conversiones) {
      const base = this.getUnidadBaseArticulo(articulo)
      const opciones = [{ value: base, label: base }]
      const existentes = new Set([base.toLowerCase()])

			;(Array.isArray(conversiones) ? conversiones : []).forEach(c => {
        const conv = ((c && c.CONVERSION) || '').toString().trim()
        if (!conv) return
        const k = conv.toLowerCase()
        if (existentes.has(k)) return
        existentes.add(k)
        opciones.push({ value: conv, label: conv })
      })

      return opciones
    },
    aplicarArticuloEnLineaCompras (linea, articulo) {
      if (!linea || !articulo) return

      const idArticuloNuevo = articulo.IDARTICULOS || null
      const mismoArticulo =
				linea.idArticuloCompras != null &&
				idArticuloNuevo != null &&
				Number(linea.idArticuloCompras) === Number(idArticuloNuevo)
      const tallaComprasAnterior = linea.tallaCompras

      const tipoTallaje = (articulo.TIPO_TALLAJE || articulo.tipoTallaje || articulo.tipo_tallaje || '').toString()
      const tallasCalzado = Array.isArray(articulo.__tallas_calzado) ? articulo.__tallas_calzado : []
      const tallasRopa = Array.isArray(articulo.__tallas_ropa) ? articulo.__tallas_ropa : []

      linea.referenciaCompras = this.limitarReferencia(articulo.CODIGO || '')
      linea.equipoCompras = articulo.DESCRIPCION || ''
      linea.idArticuloCompras = idArticuloNuevo
      linea.esCatalogadoCompras = true
      linea.descripcionArticuloOriginalCompras = articulo.DESCRIPCION || ''
      linea.tipoTallaje = tipoTallaje
      linea.tallas_calzado = tallasCalzado
      linea.tallas_ropa = tallasRopa

      const conversiones = Array.isArray(articulo.articulo_conversion)
        ? articulo.articulo_conversion
        : (Array.isArray(articulo.articuloConversion) ? articulo.articuloConversion : [])

      if (conversiones.length) {
        linea.articulo_conversion = conversiones
        const unidadBase = this.getUnidadBaseArticulo(articulo)
        linea.unidadBase = unidadBase
        const opciones = this.getOpcionesUnidadDesdeArticulo(articulo, conversiones)
        const unidadPersistida = (articulo.UNIDAD || linea.unidadMedidaCompras || '').toString().trim()
        const unidadInicial = opciones.some(o => o.value === unidadPersistida) ? unidadPersistida : unidadBase
        linea.unidadMedidaCompras = unidadInicial
      } else if (articulo.UNIDAD) {
        linea.unidadMedidaCompras = articulo.UNIDAD.toString()
      }

      if (mismoArticulo) {
        const tipoNormalizado = (tipoTallaje || '').toLowerCase()
        if (tipoNormalizado === 'calzado') {
          const permitidas = tallasCalzado.map(t => String(t && t.value != null ? t.value : t))
          linea.tallaCompras = permitidas.includes(String(tallaComprasAnterior)) ? tallaComprasAnterior : ''
        } else if (tipoNormalizado === 'ropa') {
          const permitidas = tallasRopa.map(t => String(t && t.value != null ? t.value : t))
          linea.tallaCompras = permitidas.includes(String(tallaComprasAnterior)) ? tallaComprasAnterior : ''
        } else {
          linea.tallaCompras = ''
        }
      } else {
        linea.tallaCompras = ''
      }
    },
    desvincularArticuloCatalogadoCompras (linea) {
      if (!linea) return
      linea.idArticuloCompras = null
      linea.esCatalogadoCompras = false
      linea.descripcionArticuloOriginalCompras = ''
      linea.tipoTallaje = ''
      linea.tallas_calzado = []
      linea.tallas_ropa = []
      linea.tallaCompras = ''
      if (linea.referenciaCompras && linea.referenciaCompras !== 'XXXXX') {
        linea.referenciaCompras = 'XXXXX'
      }
    },
    aplicarCambioEquipoCompras (linea) {
      if (!linea) return
      if (linea.esCatalogadoCompras && linea.descripcionArticuloOriginalCompras) {
        if (linea.equipoCompras !== linea.descripcionArticuloOriginalCompras) {
          this.desvincularArticuloCatalogadoCompras(linea)
        }
      }
      if (!linea.esCatalogadoCompras && linea.equipoCompras && linea.equipoCompras.trim() !== '') {
        if (!linea.referenciaCompras || linea.referenciaCompras.trim() === '') {
          linea.referenciaCompras = 'XXXXX'
        }
      }
    },
    seleccionarArticuloModal (articulo) {
      this.modalAñadirLinea.referencia = this.limitarReferencia(articulo.CODIGO || '')
      this.modalAñadirLinea.equipo = articulo.DESCRIPCION || ''
      this.modalAñadirLinea.unidad = articulo.UNIDAD || ''
      this.modalAñadirLinea.articuloSeleccionado = articulo
    },
    seleccionarArticuloCompras (articulo, grupoId, index) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      const linea = grupo.lineasVisibles[index]
      if (linea.tieneOrdenCompra) return
      this.aplicarArticuloEnLineaCompras(linea, articulo)
      this.actualizarLinea(grupoId, index)
    },
    seleccionarArticuloComprasPuente (articulo, seccionId, grupoId, index) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (!seccion) return
      const grupo = seccion.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      const linea = grupo.lineasVisibles[index]
      if (linea.tieneOrdenCompra) return
      this.aplicarArticuloEnLineaCompras(linea, articulo)
      this.actualizarLineaPuente(seccionId, grupoId, index)
    },
    onReferenciaComprasChange (grupoId, index) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      const linea = grupo.lineasVisibles[index]
      linea.referenciaCompras = this.limitarReferencia(linea.referenciaCompras)
      this.actualizarLinea(grupoId, index)
    },
    onReferenciaComprasChangePuente (seccionId, grupoId, index) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (!seccion) return
      const grupo = seccion.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      const linea = grupo.lineasVisibles[index]
      linea.referenciaCompras = this.limitarReferencia(linea.referenciaCompras)
      this.actualizarLineaPuente(seccionId, grupoId, index)
    },
    onEquipoComprasChange (grupoId, index) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      this.aplicarCambioEquipoCompras(grupo.lineasVisibles[index])
      this.actualizarLinea(grupoId, index)
    },
    onEquipoComprasChangePuente (seccionId, grupoId, index) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (!seccion) return
      const grupo = seccion.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return
      this.aplicarCambioEquipoCompras(grupo.lineasVisibles[index])
      this.actualizarLineaPuente(seccionId, grupoId, index)
    },
    async confirmarAñadirLinea () {
      console.log('=== CONFIRMAR AÑADIR LÍNEA ===')
      console.log('Datos del modal:', this.modalAñadirLinea)
      console.log('Validar datos:', this.validarDatosLinea)
      console.log('Tipo propuesta:', this.propuesta.tipo)
      console.log('Grupos:', this.grupos)
      console.log('Secciones:', this.secciones)

      if (!this.validarDatosLinea) {
        console.log('Validación fallida')
        this.$message.warning('Por favor, complete todos los campos requeridos')
        return
      }

      console.log('Validación OK, procediendo a añadir línea...')

      try {
        // Encontrar el grupo seleccionado
        let grupoSeleccionado = null
        if (this.propuesta.tipo === 'PUENTE') {
          const seccion = this.secciones.find(s => s.id === this.modalAñadirLinea.seccionId)
          if (seccion) {
            grupoSeleccionado = seccion.grupos.find(g => g.id === this.modalAñadirLinea.grupoId)
          }
        } else {
          grupoSeleccionado = this.grupos.find(g => g.id === this.modalAñadirLinea.grupoId)
        }

        if (!grupoSeleccionado) {
          this.$message.error('Error: Grupo no encontrado')
          return
        }

        // Calcular la siguiente posición
        let siguientePosicion = 1
        if (this.propuesta.tipo === 'PUENTE') {
          const seccion = this.secciones.find(s => s.id === this.modalAñadirLinea.seccionId)
          if (seccion) {
            seccion.grupos.forEach(g => {
              if (g.id === this.modalAñadirLinea.grupoId) {
                g.lineasVisibles.forEach(linea => {
                  const pos = parseInt(linea.posicion) || 0
                  if (pos >= siguientePosicion) {
                    siguientePosicion = pos + 1
                  }
                })
              }
            })
          }
        } else {
          this.grupos.forEach(g => {
            if (g.id === this.modalAñadirLinea.grupoId) {
              g.lineasVisibles.forEach(linea => {
                const pos = parseInt(linea.posicion) || 0
                if (pos >= siguientePosicion) {
                  siguientePosicion = pos + 1
                }
              })
            }
          })
        }

        // Crear la nueva línea
        const nuevaLinea = {
          id: null,
          posicion: siguientePosicion.toString(),
          referencia: this.limitarReferencia(this.modalAñadirLinea.referencia.trim()),
          equipo: this.modalAñadirLinea.equipo.trim(),
          cantidad: this.modalAñadirLinea.cantidad,
          unidad: this.modalAñadirLinea.unidad.trim(),
          cantidadCompras: '',
          unidadMedidaCompras: '',
          notas: '',
          anotacionesTecnico: '',
          notasCompras: '',
          precio: '',
          descuento: '',
          referenciaCompras: '',
          equipoCompras: '',
          tallaCompras: '',
          esCatalogadoCompras: false,
          idArticuloCompras: null,
          descripcionArticuloOriginalCompras: '',
          proveedorOfertaIds: [],
          proveedoresOfertaLanzados: [],
          proveedorId: null,
          proveedor: '',
          tieneOferta: false,
          tieneOrdenCompra: false,
          estado: 1,
          ANOTACIONES_TECNICO: '',
          idArticulo: this.modalAñadirLinea.articuloSeleccionado ? this.modalAñadirLinea.articuloSeleccionado.IDARTICULOS || null : null,
          esCatalogado: !!this.modalAñadirLinea.articuloSeleccionado,
          tipoTallaje: this.modalAñadirLinea.articuloSeleccionado
            ? (this.modalAñadirLinea.articuloSeleccionado.TIPO_TALLAJE || this.modalAñadirLinea.articuloSeleccionado.tipoTallaje || '')
            : '',
          tallas_calzado: this.modalAñadirLinea.articuloSeleccionado && Array.isArray(this.modalAñadirLinea.articuloSeleccionado.__tallas_calzado)
            ? this.modalAñadirLinea.articuloSeleccionado.__tallas_calzado
            : [],
          tallas_ropa: this.modalAñadirLinea.articuloSeleccionado && Array.isArray(this.modalAñadirLinea.articuloSeleccionado.__tallas_ropa)
            ? this.modalAñadirLinea.articuloSeleccionado.__tallas_ropa
            : [],
          talla: ''
        }

        // Añadir la línea al grupo correspondiente
        if (this.propuesta.tipo === 'PUENTE') {
          const seccion = this.secciones.find(s => s.id === this.modalAñadirLinea.seccionId)
          if (seccion) {
            const grupo = seccion.grupos.find(g => g.id === this.modalAñadirLinea.grupoId)
            if (grupo) {
              grupo.lineas.push(nuevaLinea)
              grupo.lineasVisibles.push(nuevaLinea)
              if (!grupo.visible) {
                grupo.visible = true
              }
              if (!seccion.visible) {
                seccion.visible = true
              }
            }
          }
        } else {
          const grupo = this.grupos.find(g => g.id === this.modalAñadirLinea.grupoId)
          if (grupo) {
            grupo.lineas.push(nuevaLinea)
            grupo.lineasVisibles.push(nuevaLinea)
            if (!grupo.visible) {
              grupo.visible = true
            }
          }
        }

        this.$message.success('Línea añadida correctamente')
        this.modalAñadirLinea.visible = false
      } catch (error) {
        console.error('Error al añadir línea:', error)
        this.$message.error('Error al añadir la línea')
      }
    },
    abrirModalCerrarPropuesta () {
      if (!this.propuesta || !this.propuesta.id) {
        this.$message.warning('No hay propuesta cargada')
        return
      }
      this.modalCerrarPropuesta.mensaje = ''
      this.modalCerrarPropuesta.visible = true
    },
    async confirmarCerrarPropuesta () {
      if (!this.propuesta || !this.propuesta.id) {
        this.$message.warning('No hay propuesta cargada')
        return
      }
      try {
        this.modalCerrarPropuesta.cerrando = true
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }
        const payload = {
          id: this.propuesta.id,
          mensaje: (this.modalCerrarPropuesta.mensaje || '').trim()
        }
        // Endpoint pendiente de backend. Se deja preparado para integración.
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/cerrarPropuestaCompras`,
          payload
        )
        if (response.data && !response.data.error) {
          this.$message.success('Propuesta cerrada correctamente')
          this.modalCerrarPropuesta.visible = false
          this.volverAlDashboard()
        } else {
          const mensaje = (response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudo cerrar la propuesta'
          this.$message.error(mensaje)
        }
      } catch (error) {
        const status = error && error.response ? error.response.status : null
        if (status === 404 || status === 501) {
          this.$message.warning('El endpoint de cierre de propuesta aún no está disponible en backend')
        } else {
          console.error('Error al cerrar propuesta:', error)
          this.$message.error('Error al cerrar la propuesta')
        }
      } finally {
        this.modalCerrarPropuesta.cerrando = false
      }
    },
    async confirmarProveedor () {
      const esOferta = this.modalProveedor.accion === 'oferta'
      const proveedoresOferta = (this.modalProveedor.proveedoresSeleccionadosOferta || [])
        .map(id => Number(id))
        .filter(id => !isNaN(id))

      if (esOferta) {
        if (!proveedoresOferta.length) {
          this.$message.warning('Por favor, seleccione al menos un proveedor')
          return
        }
      } else if (!this.modalProveedor.proveedorSeleccionado) {
        this.$message.warning('Por favor, seleccione un proveedor')
        return
      }

      if (this.modalProveedor.accion === 'ordenCompra') {
        const f = this.formOrdenCompra
        if (!f.idSeccionesPedido || !f.idTipoEnvio || !f.idCondicionesEnvio || f.plazoEntrega == null || f.plazoEntrega === '' || !f.idCondicionesPedido || !f.idFormaPago || !f.idDivisa || !f.idDireccionEntrega) {
          this.$message.warning('Complete todos los campos del formulario de orden de compra')
          return
        }
        if (f.idDireccionEntrega === '__otros__' && (!f.direccionEntregaTexto || !f.direccionEntregaTexto.trim())) {
          this.$message.warning('Indique la dirección de entrega para la opción "Otros"')
          return
        }
        if (!this.validarCantidadesComprasParaProveedor(this.modalProveedor.proveedorSeleccionado)) {
          return
        }
      }

      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        // Guardar siempre antes de lanzar oferta u orden de compra
        const guardadoOk = await this.guardarPropuesta(false)
        if (!guardadoOk) {
          this.$message.warning('No se pudo guardar la propuesta. No se lanzó la acción.')
          return
        }

        let lineas = []
        if (this.modalProveedor.accion === 'oferta') {
          if (proveedoresOferta.length === 1) {
            lineas = this.recopilarLineasParaLanzarOferta(proveedoresOferta[0])
            if (lineas.length === 0) {
              this.$message.warning('No hay líneas pendientes de oferta para este proveedor.')
              return
            }
          } else {
            lineas = this.recopilarLineasParaLanzarOfertaMultiples(proveedoresOferta)
          }
        } else if (this.modalProveedor.accion === 'ordenCompra') {
          lineas = this.recopilarLineasParaLanzarOrdenCompra(this.modalProveedor.proveedorSeleccionado)
          if (lineas.length === 0) {
            this.$message.warning('No hay líneas pendientes de compra para este proveedor.')
            return
          }
        }

        let endpoint = ''
        let mensajeExito = ''

        if (this.modalProveedor.accion === 'oferta') {
          endpoint = `${endpoints.backend}entidad/propuestas_pedido/buscador/lanzarOferta`
          mensajeExito = 'Oferta lanzada correctamente'
        } else if (this.modalProveedor.accion === 'ordenCompra') {
          endpoint = `${endpoints.backend}entidad/propuestas_pedido/buscador/lanzarOrdenCompra`
          mensajeExito = 'Orden de compra lanzada correctamente'
        }

        const payload = {
          id: this.propuesta.id,
          lineas: lineas
        }
        if (this.modalProveedor.accion === 'oferta') {
          if (proveedoresOferta.length === 1) {
            payload.proveedorId = proveedoresOferta[0]
          } else {
            payload.proveedorIds = proveedoresOferta
          }
        } else {
          payload.proveedorId = this.modalProveedor.proveedorSeleccionado
        }
        if (this.modalProveedor.accion === 'ordenCompra') {
          payload.IDSECCIONES_PEDIDO = this.formOrdenCompra.idSeccionesPedido
          payload.IDTIPO_ENVIO = this.formOrdenCompra.idTipoEnvio
          payload.IDCONDICIONES_ENVIO = this.formOrdenCompra.idCondicionesEnvio
          payload.PLAZO_ENTREGA = Number(this.formOrdenCompra.plazoEntrega)
          payload.IDCONDICIONES_PEDIDO = this.formOrdenCompra.idCondicionesPedido
          payload.IDFORMA_PAGO = this.formOrdenCompra.idFormaPago
          payload.IDDIVISAS = this.formOrdenCompra.idDivisa
          payload.ID_DIRECCION_ENTREGA = this.formOrdenCompra.idDireccionEntrega
          payload.DIRECCION_ENTREGA_TEXTO = this.direccionEntregaTexto ? this.direccionEntregaTexto.trim() : ''
          payload.MOTIVO_ACEPTACION = this.formOrdenCompra.motivoAceptacionOferta ? this.formOrdenCompra.motivoAceptacionOferta.trim() : ''
          if (this.formOrdenCompra.descuentoGeneralPedido != null && this.formOrdenCompra.descuentoGeneralPedido !== '') {
            payload.DESCUENTO_PEDIDO = Number(this.formOrdenCompra.descuentoGeneralPedido)
          }
          payload.PORTES = this.formOrdenCompra.portes != null && this.formOrdenCompra.portes !== ''
            ? Number(this.formOrdenCompra.portes)
            : 0
        }
        const response = await axios.post(endpoint, payload)
        const data = response.data || {}
        const exito = data.success === true || (data.success !== false && !data.error)

        if (exito) {
          this.$message.success(data.mensaje || mensajeExito)
          if (Array.isArray(data.errores) && data.errores.length) {
            data.errores.forEach((err) => {
              const texto = err && err.mensaje
                ? err.mensaje
                : `No se pudo lanzar la oferta al proveedor ${err && err.proveedorId != null ? err.proveedorId : ''}`
              this.$message.warning(texto)
            })
          }
          this.modalProveedor.visible = false

          // Actualizar solo los indicadores de las líneas sin recargar toda la propuesta
          // para preservar los proveedores asignados a cada línea
          if (data.lineas && Array.isArray(data.lineas)) {
            this.actualizarIndicadoresLineas(data.lineas)
          } else {
            // Si el backend no devuelve las líneas actualizadas, recargar toda la propuesta
            await this.cargarPropuestaSeleccionada(this.propuesta.id)
          }
        } else {
          const mensaje = data.mensaje ? data.mensaje : 'Error al lanzar la acción'
          this.$message.error(mensaje)
        }
      } catch (error) {
        console.error('Error al lanzar acción:', error)
        const mensaje = error.response && error.response.data && error.response.data.mensaje
          ? error.response.data.mensaje
          : 'Error al procesar la solicitud. Por favor, intente nuevamente.'
        this.$message.error(mensaje)
      }
    },
    actualizarNombresProveedores () {
      // Actualizar el nombre del proveedor en las líneas basándose en el proveedorId
      // Solo actualizar si el nombre no está ya establecido desde el backend
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(linea => {
              if (linea.proveedorId && !linea.proveedor) {
                // Comparar como números para evitar problemas de tipo
                const proveedor = this.listaProveedores.find(p => Number(p.id) === Number(linea.proveedorId))
                if (proveedor) {
                  linea.proveedor = proveedor.nombre
                }
              }
            })
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(linea => {
            if (linea.proveedorId && !linea.proveedor) {
              // Comparar como números para evitar problemas de tipo
              const proveedor = this.listaProveedores.find(p => Number(p.id) === Number(linea.proveedorId))
              if (proveedor) {
                linea.proveedor = proveedor.nombre
              }
            }
          })
        })
      }
    },
    actualizarIndicadoresLineas (lineasBackend) {
      // Actualizar solo los indicadores (tieneOferta, tieneOrdenCompra) de las líneas existentes
      // sin modificar el proveedorId para preservar los proveedores asignados a cada línea.
      const lineasMap = new Map()
      lineasBackend.forEach(lineaBackend => {
        lineasMap.set(lineaBackend.id, {
          tieneOferta: lineaBackend.tieneOferta || false,
          tieneOrdenCompra: lineaBackend.tieneOrdenCompra || false,
          proveedoresOfertaLanzados: this.normalizarProveedoresOfertaLanzados(lineaBackend.proveedoresOfertaLanzados)
        })
      })

      const aplicarIndicadores = (linea) => {
        if (!linea.id || !lineasMap.has(linea.id)) return
        const indicadores = lineasMap.get(linea.id)
        linea.tieneOferta = indicadores.tieneOferta
        linea.tieneOrdenCompra = indicadores.tieneOrdenCompra
        linea.proveedoresOfertaLanzados = indicadores.proveedoresOfertaLanzados
        if (indicadores.tieneOrdenCompra) {
          linea.estado = 2
        }
      }

      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(aplicarIndicadores)
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(aplicarIndicadores)
        })
      }
    },
    actualizarCamposLineasDesdeBackend (lineasBackend) {
      if (!Array.isArray(lineasBackend) || lineasBackend.length === 0) return

      const lineasMap = new Map()
      lineasBackend.forEach(lb => {
        const key = (lb && lb.id != null) ? lb.id : ((lb && lb.idLineaPropuesta != null) ? lb.idLineaPropuesta : null)
        if (key != null) lineasMap.set(key, lb)
      })

      const actualizarLinea = (linea, lb) => {
        if (!linea || !lb) return

        const cantidadGestion = this.getCantidadGestion(lb)
        if (lb.cantidad !== undefined || lb.cantidadAprobada !== undefined || lb.CANTIDAD_APROBADA !== undefined) {
          linea.cantidad = cantidadGestion.cantidad
          linea.cantidadSolicitada = cantidadGestion.cantidadSolicitada
          linea.cantidadAprobada = cantidadGestion.cantidadAprobada
        }
        if (lb.unidad !== undefined) linea.unidad = lb.unidad
        if (lb.referencia !== undefined) linea.referencia = lb.referencia || ''
        if (lb.equipo !== undefined) linea.equipo = lb.equipo || ''
        if (lb.talla !== undefined) linea.talla = lb.talla
        if (lb.idArticulo !== undefined || lb.IDARTICULOS !== undefined) {
          linea.idArticulo = lb.idArticulo || lb.IDARTICULOS || null
        }
        if (lb.esCatalogado !== undefined) linea.esCatalogado = !!lb.esCatalogado
        if (lb.tipoTallaje !== undefined || lb.TIPO_TALLAJE !== undefined || lb.tipo_tallaje !== undefined) {
          linea.tipoTallaje = lb.tipoTallaje || lb.TIPO_TALLAJE || lb.tipo_tallaje || ''
        }
        if (Array.isArray(lb.tallas_calzado)) linea.tallas_calzado = lb.tallas_calzado
        if (Array.isArray(lb.tallas_ropa)) linea.tallas_ropa = lb.tallas_ropa
        if (lb.cantidadCompras !== undefined) {
          linea.cantidadCompras = lb.cantidadCompras
        } else if (lb.cantidad !== undefined || lb.cantidadAprobada !== undefined || lb.CANTIDAD_APROBADA !== undefined) {
          linea.cantidadCompras = cantidadGestion.cantidad
        }
        if (lb.unidadMedidaCompras !== undefined) linea.unidadMedidaCompras = lb.unidadMedidaCompras
        if (lb.precio !== undefined) linea.precio = lb.precio
        if (lb.descuento !== undefined) linea.descuento = lb.descuento != null ? lb.descuento : ''
        if (lb.referenciaCompras !== undefined) linea.referenciaCompras = lb.referenciaCompras || ''
        if (lb.equipoCompras !== undefined) linea.equipoCompras = lb.equipoCompras || ''
        if (lb.tallaCompras !== undefined || lb.TALLA_COMPRAS !== undefined) {
          linea.tallaCompras = lb.tallaCompras || lb.TALLA_COMPRAS || ''
        }
        if (lb.stock_disponible !== undefined) linea.stock_disponible = lb.stock_disponible
        if (lb.proveedores_asignados !== undefined) {
          linea.proveedores_asignados = Array.isArray(lb.proveedores_asignados) ? lb.proveedores_asignados : []
        }

        if (lb.estado !== undefined && lb.estado !== null) {
          linea.estado = this.normalizarEstadoLinea(lb.estado)
        }
        if (lb.ESTADO_INSPECCION !== undefined || lb.estadoInspeccion !== undefined || lb.estado_inspeccion !== undefined) {
          const estadoInspector = lb.ESTADO_INSPECCION || lb.estadoInspeccion || lb.estado_inspeccion || ''
          linea.requiereRevisionInspector = this.esEstadoInspectorRC(estadoInspector)
        }
        if (lb.ANOTACIONES_TECNICO !== undefined || lb.anotacionesTecnico !== undefined) {
          const anotaciones = this.resolverAnotacionesTecnico(lb)
          linea.ANOTACIONES_TECNICO = anotaciones
          linea.anotacionesTecnico = anotaciones
        }
        if (lb.notasCompras !== undefined || lb.NOTAS_COMPRAS !== undefined) {
          linea.notasCompras = lb.notasCompras || lb.NOTAS_COMPRAS || ''
        }
        if (lb.tieneOferta !== undefined) linea.tieneOferta = !!lb.tieneOferta
        if (lb.tieneOrdenCompra !== undefined) linea.tieneOrdenCompra = !!lb.tieneOrdenCompra
        if (lb.proveedoresOfertaLanzados !== undefined) {
          linea.proveedoresOfertaLanzados = this.normalizarProveedoresOfertaLanzados(lb.proveedoresOfertaLanzados)
        }
      }

      const actualizarEnColeccion = (coleccion) => {
        if (!Array.isArray(coleccion)) return
        coleccion.forEach(linea => {
          const key = (linea && linea.id != null) ? linea.id : ((linea && linea.idLineaPropuesta != null) ? linea.idLineaPropuesta : null)
          if (key != null && lineasMap.has(key)) {
            actualizarLinea(linea, lineasMap.get(key))
          }
        })
      }

      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            actualizarEnColeccion(grupo.lineasVisibles)
            actualizarEnColeccion(grupo.lineas)
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          actualizarEnColeccion(grupo.lineasVisibles)
          actualizarEnColeccion(grupo.lineas)
        })
      }
    },
    cerrarVentana () {
      // Cerrar solo la ventana
      if (window.parent && window.parent !== window) {
        if (window.parent.Vue && window.parent.Vue.prototype) {
          window.parent.Vue.prototype.$root.$emit('cerrar-ventana-propuesta')
        } else {
          window.parent.postMessage({ type: 'cerrar-ventana-propuesta' }, '*')
        }
      } else {
        this.$root.$emit('cerrar-ventana-propuesta')
      }
    },
    volverAlDashboard () {
      // Navegar al dashboard de compras
      this.$router.push({ name: 'dashboard_compras' })
    },
    getLabelPropuesta (prop) {
      const buque = prop.buque || (prop.cabecera && prop.cabecera.buque) || ''
      const tipo = prop.tipo || (prop.cabecera && prop.cabecera.tipo) || 'MAQUINAS'
      return `${prop.codigo} - ${buque} (${tipo})`
    },
    async abrirModalOfertasLinea (linea) {
      this.modalOfertasLinea.lineaSeleccionada = linea
      this.modalOfertasLinea.modo = 'linea'
      this.modalOfertasLinea.visible = true

      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        // Cargar ofertas de esta línea específica
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/ofertasPorLinea`,
          { lineaId: linea.id, propuestaId: this.propuesta.id }
        )

        if (response.data) {
          // El backend devuelve { success: true, data: [...] }
          if (response.data.success && Array.isArray(response.data.data)) {
            this.modalOfertasLinea.ofertas = response.data.data
          } else if (Array.isArray(response.data)) {
            // Fallback: si la respuesta es directamente un array
            this.modalOfertasLinea.ofertas = response.data
          } else if (response.data.data && Array.isArray(response.data.data)) {
            // Fallback: si viene en response.data.data
            this.modalOfertasLinea.ofertas = response.data.data
          } else {
            this.modalOfertasLinea.ofertas = []
          }
        } else {
          this.modalOfertasLinea.ofertas = []
        }
      } catch (error) {
        console.error('Error al cargar ofertas de la línea:', error)
        this.$message.error('Error al cargar las ofertas de la línea')
        this.modalOfertasLinea.ofertas = []
      }
    },
    async verOfertaCompleta (oferta) {
      this.modalOfertasLinea.ofertaSeleccionada = oferta
      this.modalOfertasLinea.modo = 'oferta'

      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        // Cargar todas las líneas de esta oferta
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/lineasPorOferta`,
          			{ ofertaId: oferta.idOferta }
        )

        if (response.data) {
          // El backend devuelve { success: true, data: [...] }
          if (response.data.success && Array.isArray(response.data.data)) {
            this.modalOfertasLinea.lineasOferta = response.data.data
          } else if (Array.isArray(response.data)) {
            // Fallback: si la respuesta es directamente un array
            this.modalOfertasLinea.lineasOferta = response.data
          } else if (response.data.data && Array.isArray(response.data.data)) {
            // Fallback: si viene en response.data.data
            this.modalOfertasLinea.lineasOferta = response.data.data
          } else {
            this.modalOfertasLinea.lineasOferta = []
          }
        } else {
          this.modalOfertasLinea.lineasOferta = []
        }
      } catch (error) {
        console.error('Error al cargar líneas de la oferta:', error)
        this.$message.error('Error al cargar las líneas de la oferta')
        this.modalOfertasLinea.lineasOferta = []
      }
    },
    volverAOfertasLinea () {
      this.modalOfertasLinea.modo = 'linea'
      this.modalOfertasLinea.ofertaSeleccionada = null
      this.modalOfertasLinea.lineasOferta = []
    },
    async abrirModalTodasOfertas () {
      this.modalTodasOfertas.modo = 'lista'
      this.modalTodasOfertas.visible = true

      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        // Cargar todas las ofertas de esta propuesta
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/ofertasPorPropuesta`,
          { propuestaId: this.propuesta.id }
        )

        if (response.data) {
          // El backend devuelve { success: true, data: [...] }
          if (response.data.success && Array.isArray(response.data.data)) {
            this.modalTodasOfertas.ofertas = response.data.data
          } else if (Array.isArray(response.data)) {
            // Fallback: si la respuesta es directamente un array
            this.modalTodasOfertas.ofertas = response.data
          } else if (response.data.data && Array.isArray(response.data.data)) {
            // Fallback: si viene en response.data.data
            this.modalTodasOfertas.ofertas = response.data.data
          } else {
            this.modalTodasOfertas.ofertas = []
          }
        } else {
          this.modalTodasOfertas.ofertas = []
        }
      } catch (error) {
        console.error('Error al cargar ofertas de la propuesta:', error)
        this.$message.error('Error al cargar las ofertas de la propuesta')
        this.modalTodasOfertas.ofertas = []
      }
    },
    async verOfertaDesdeLista (oferta) {
      this.modalTodasOfertas.ofertaSeleccionada = oferta
      this.modalTodasOfertas.modo = 'detalle'

      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        // Cargar todas las líneas de esta oferta
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/lineasPorOferta`,
          { ofertaId: oferta.id }
        )

        if (response.data) {
          // El backend devuelve { success: true, data: [...] }
          if (response.data.success && Array.isArray(response.data.data)) {
            this.modalTodasOfertas.lineasOferta = response.data.data
          } else if (Array.isArray(response.data)) {
            // Fallback: si la respuesta es directamente un array
            this.modalTodasOfertas.lineasOferta = response.data
          } else if (response.data.data && Array.isArray(response.data.data)) {
            // Fallback: si viene en response.data.data
            this.modalTodasOfertas.lineasOferta = response.data.data
          } else {
            this.modalTodasOfertas.lineasOferta = []
          }
        } else {
          this.modalTodasOfertas.lineasOferta = []
        }
      } catch (error) {
        console.error('Error al cargar líneas de la oferta:', error)
        this.$message.error('Error al cargar las líneas de la oferta')
        this.modalTodasOfertas.lineasOferta = []
      }
    },
    volverAListaOfertas () {
      this.modalTodasOfertas.modo = 'lista'
      this.modalTodasOfertas.ofertaSeleccionada = null
      this.modalTodasOfertas.lineasOferta = []
    },
    async descargarDocumentoLinea (linea) {
      const idLinea = linea.idLineaPropuesta || linea.id
      if (!idLinea) {
        this.$message.warning('No hay documento para descargar')
        return
      }
      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }
        const url = `${endpoints.backend}entidad/lineas_propuesta_pedido/${idLinea}/descargarDocumento`
        const response = await axios.post(url, null, { responseType: 'blob' })
        const blob = response.data
        if (!(blob instanceof Blob)) {
          this.$message.error('La respuesta no es un archivo válido')
          return
        }
        // Si el backend devuelve error en JSON con content-type application/json, el blob puede ser el mensaje de error
        const contentType = response.headers['content-type'] || ''
        if (contentType.indexOf('application/json') !== -1) {
          this.$message.error('No se pudo descargar el documento')
          return
        }
        const contentDisposition = response.headers['content-disposition']
        let nombre = 'documento-linea'
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if (match && match[1]) nombre = match[1].replace(/['"]/g, '').trim()
        }
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = nombre
        link.click()
        window.URL.revokeObjectURL(link.href)
        this.$message.success('Descarga iniciada')
      } catch (error) {
        console.error('Error al descargar documento:', error)
        this.$message.error(error.response && error.response.status === 404 ? 'Documento no encontrado' : 'Error al descargar el documento')
      }
    },
    abrirSubirDocumento (oferta) {
      this.modalSubirDocumento.ofertaId = oferta.id
      this.modalSubirDocumento.archivoSeleccionado = null
      this.modalSubirDocumento.visible = true
      // Limpiar el input file
      this.$nextTick(() => {
        if (this.$refs.inputFileDocumento) {
          this.$refs.inputFileDocumento.value = ''
        }
      })
    },
    onFileSelected (event) {
      const file = event.target.files[0]
      if (file) {
        this.modalSubirDocumento.archivoSeleccionado = file
      }
    },
    async subirDocumento () {
      if (!this.modalSubirDocumento.archivoSeleccionado || !this.modalSubirDocumento.ofertaId) {
        this.$message.warning('Por favor, seleccione un archivo')
        return
      }

      this.modalSubirDocumento.subiendo = true

      try {
        // Convertir archivo a base64
        const file = this.modalSubirDocumento.archivoSeleccionado
        const base64 = await this.fileToBase64(file)

        // Obtener el tipo MIME del archivo
        const mimeType = file.type || 'application/octet-stream'

        // Construir el payload según el formato especificado
        const payload = {
          DOCUMENTO: {
            attr: {
              divider: true,
              col: 24
            },
            format: "file",
            obligatorio: 1,
            class: null,
            textpre: "",
            textpos: "",
            title: "Documento",
            title2: null,
            subtitle: null,
            value: {
              file: {},
              base64: `data:${mimeType};base64,${base64}`,
              name: file.name
            }
          }
        }

        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        // Enviar al backend
        const response = await axios.post(
          `${endpoints.backend}entidad/ofertas_compra/${this.modalSubirDocumento.ofertaId}/subirDocumento`,
          payload
        )

        if (response.data && !response.data.error) {
          this.$message.success('Documento subido correctamente')
          this.modalSubirDocumento.visible = false
          this.modalSubirDocumento.archivoSeleccionado = null
          this.modalSubirDocumento.ofertaId = null
        } else {
          const mensaje = (response.data && response.data.mensaje) ? response.data.mensaje : 'Error al subir el documento'
          this.$message.error(mensaje)
        }
      } catch (error) {
        console.error('Error al subir documento:', error)
        this.$message.error('Error al subir el documento. Por favor, intente nuevamente.')
      } finally {
        this.modalSubirDocumento.subiendo = false
      }
    },
    fileToBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          // Remover el prefijo "data:mime/type;base64," del resultado
          const base64String = reader.result.split(',')[1]
          resolve(base64String)
        }
        reader.onerror = error => reject(error)
        reader.readAsDataURL(file)
      })
    },
    actualizarPrecioOferta (lineaOferta) {
      // El precio se actualiza directamente en el v-model
      // Se guardará cuando el usuario haga clic en "Guardar Precios"
    },
    async guardarPreciosOfertas () {
      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        let lineasAGuardar = []
        if (this.modalOfertasLinea.modo === 'oferta') {
          // Guardar líneas de la oferta vista desde modalOfertasLinea
          lineasAGuardar = this.modalOfertasLinea.lineasOferta
        } else if (this.modalOfertasLinea.modo === 'linea') {
          // Guardar ofertas de la línea (cada oferta tiene un precio editable)
          lineasAGuardar = this.modalOfertasLinea.ofertas
        } else if (this.modalTodasOfertas.modo === 'detalle') {
          // Guardar líneas de la oferta vista desde modalTodasOfertas
          lineasAGuardar = this.modalTodasOfertas.lineasOferta
        }

        if (lineasAGuardar.length === 0) {
          this.$message.warning('No hay precios para guardar')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/actualizarPreciosOfertas`,
          { lineas: lineasAGuardar }
        )

        if (response.data && !response.data.error) {
          this.$message.success('Precios guardados correctamente')
          // Recargar los datos si es necesario
        } else {
          this.$message.error('Error al guardar los precios')
        }
      } catch (error) {
        console.error('Error al guardar precios:', error)
        this.$message.error('Error al guardar los precios')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.gestionar-propuestas-compras-page {
	height: 100vh;
	overflow: auto;
	background-color: $--color-background;
}

.propuesta-container {
	padding: 20px;
}

.propuesta-header {
	background-color: white;
	padding: 15px;
	border-radius: 4px;
	margin-bottom: 20px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);

	.header-row {
		display: grid;
		grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
		gap: 15px;
		margin-bottom: 15px;
		align-items: center;
	}

	.header-field {
		label {
			display: block;
			font-weight: bold;
			margin-bottom: 5px;
			font-size: 0.9rem;
		}

		&.header-title {
			text-align: center;
			h2 {
				margin: 0;
				font-size: 1.2rem;
				color: $--color-primary;
			}
		}
	}

	.propuesta-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		padding-top: 10px;
		border-top: 1px solid #eee;
	}

	.propuesta-actions-buttons {
		display: flex;
		gap: 10px;
	}
}

.propuesta-table-container {
	background-color: white;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
	overflow: hidden;
}

.table-header {
	display: grid;
	grid-template-columns: 40px 80px 200px 1fr 100px 120px 140px 150px 150px 120px minmax(120px, 0.7fr) 140px;
	background-color: $--color-main-header;
	color: white;
	font-weight: bold;
	font-size: 0.85rem;
	padding: 0.5rem;
	border-bottom: 2px solid $--color-main-header;

	> div {
		padding: 0.25rem;
		display: flex;
		align-items: center;
	}
}

.grupo-section {
	.table-row {
		display: grid;
		grid-template-columns: 40px 80px 200px 1fr 100px 120px 140px 150px 150px 120px minmax(120px, 0.7fr) 140px;
		border-bottom: 1px solid #c0c4cc;
		transition: background-color 0.2s;

		&:hover {
			background-color: rgba($--color-header, 0.05);
		}

		&.table-row-seleccionada {
			background-color: rgba($--color-primary, 0.08);
		}

		> div {
			padding: 0.5rem;
			display: flex;
			align-items: center;
			border-right: 1px solid #c0c4cc;

			&:last-child {
				border-right: none;
			}
		}

		.col-seleccion {
			justify-content: center;
		}

		.col-posicion {
			flex-direction: column;
			justify-content: center;
			align-items: center;
			gap: 2px;
		}

		.col-referencia,
		.col-equipo,
		.col-notas {
			min-width: 0;
			flex-direction: column;
			align-items: stretch;
			gap: 4px;

			::v-deep .el-input {
				width: 100%;
			}

			::v-deep .el-input__inner {
				padding-left: 8px;
				padding-right: 8px;
			}
		}

		.col-equipo {
			.equipo-catalogo-row {
				display: flex;
				align-items: flex-start;
				gap: 8px;
				width: 100%;
			}

			.equipo-input-wrap {
				flex: 1 1 auto;
				min-width: 0;

				::v-deep .el-autocomplete,
				::v-deep .el-input {
					width: 100%;
				}
			}

			.talla-inline {
				flex: 0 0 140px;
				min-width: 80px;
			}
		}
		.nota-row {
			display: flex;
			align-items: center;
			gap: 4px;
		}
		.nota-label {
			width: 18px;
			font-size: 10px;
			color: #666;
			font-weight: bold;
			flex-shrink: 0;
		}

		.celda-equipo-tooltip {
			display: block;
			width: 100%;
			min-width: 0;

			::v-deep .el-input__inner {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}

    .celda-notas-tooltip {
			display: block;
			width: 100%;
			min-width: 0;

			::v-deep .el-input__inner {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}

		.pos-indicadores {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 6px;
			height: 16px;
		}

		.posicion-text {
			display: inline-block;
		}

		.indicador-letra {
			font-size: 18px;
			font-weight: 800;
			cursor: pointer;
			user-select: none;
			line-height: 1;
		}

		.indicador-p {
			color: #e6a23c;
		}

		.indicador-s {
			color: #f56c6c;
		}

		.indicador-rc {
			font-size: 13px;
			font-weight: 800;
			color: #f56c6c;
		}

		.col-acciones {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			align-items: center;
			align-content: flex-start;
			justify-content: flex-start;
			gap: 6px;

			.el-button {
				margin: 0;
			}
		}

		.col-precio {
			flex-direction: column;
			align-items: stretch;
			gap: 4px;

			::v-deep .el-input {
				width: 100%;
			}

			::v-deep .el-input__inner {
				text-align: right;
			}

			::v-deep .el-input-group__prepend {
				padding: 0 8px;
				font-size: 12px;
			}
		}

		.col-estado {
			&.estado-aceptado {
				background-color: rgba(76, 175, 80, 0.25);
				border-radius: 4px;
			}
			&.estado-no-aceptado {
				background-color: rgba(244, 67, 54, 0.25);
				border-radius: 4px;
			}
			&.estado-stock-almacen {
				background-color: rgba(33, 150, 243, 0.25);
				border-radius: 4px;
			}
			.estado-indicadores {
				display: flex;
				align-items: center;
				gap: 5px;
			}
			.estado-compras {
				min-width: 0;
			}
		}

		// Estilos para los inputs dentro de las filas
		::v-deep .el-input {
			.el-input__inner {
				border-color: #c0c4cc;
				border-width: 1px;

				&:hover {
					border-color: #a0a4a8;
				}

				&:focus {
					border-color: $--color-primary;
				}

				&::placeholder {
					color: #909399;
					opacity: 1;
				}
			}
		}

		.col-cantidad {
			display: flex;
			flex-direction: column;
			gap: 4px;

			::v-deep .el-input {
				width: 100%;
				display: block;

				.el-input__inner {
					text-align: right;
					border-color: #c0c4cc;
					width: 100%;

					&:hover {
						border-color: #a0a4a8;
					}

					&:focus {
						border-color: $--color-primary;
					}

					&::placeholder {
						color: #909399;
						opacity: 1;
					}
				}
			}

			.conversion-info {
				font-size: 12px;
				color: #606266;
				text-align: right;
				white-space: nowrap;
			}

			::v-deep .cantidad-compras-invalida .el-input__inner {
				border-color: #f56c6c !important;
			}

			::v-deep .cantidad-compras-invalida .el-input__inner:focus {
				border-color: #f56c6c !important;
				box-shadow: 0 0 0 1px rgba(245, 108, 108, 0.2);
			}
		}

		.col-unidad {
			display: flex;
			flex-direction: column;
			gap: 4px;

			::v-deep .el-input {
				width: 100%;
				display: block;

				.el-input__inner {
					border-color: #c0c4cc;
					width: 100%;

					&:hover {
						border-color: #a0a4a8;
					}

					&:focus {
						border-color: $--color-primary;
					}

					&::placeholder {
						color: #909399;
						opacity: 1;
					}
				}
			}
		}
	}
}

.grupo-section {
	border: 2px solid transparent;

	.grupo-header {
		color: #000;
		font-weight: bold;
		padding: 0.75rem 1rem;
		border-bottom: 1px solid #dcdfe6;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		transition: all 0.2s;
		font-size: 0.9rem;
		position: relative;

		&:hover {
			opacity: 0.85;
		}

		&.grupo-collapsed {
			opacity: 0.9;
		}

		i {
			font-size: 0.9rem;
			color: #000;
			font-weight: bold;
		}

		.grupo-nombre {
			font-weight: bold;
		}
	}
}

.seccion-section {
	margin-bottom: 1rem;

	.seccion-header {
		color: white;
		font-weight: bold;
		padding: 1rem;
		border-bottom: 2px solid rgba(0, 0, 0, 0.2);
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		transition: all 0.2s;
		font-size: 1.1rem;

		&:hover {
			opacity: 0.9;
		}

		&.seccion-collapsed {
			opacity: 0.8;
		}

		i {
			font-size: 1rem;
			color: white;
			font-weight: bold;
		}

		.seccion-nombre {
			font-weight: bold;
		}
	}
}

// Bordes según la sección padre para PUENTE
.seccion-cubierta .grupo-section {
	border-color: #f44336; // Rojo para CUBIERTA
}

.seccion-fonda .grupo-section {
	border-color: #4caf50; // Verde para FONDA
}

.seccion-puente .grupo-section {
	border-color: #2196f3; // Azul para PUENTE
}

// Colores específicos por sección según la imagen
.seccion-cubierta {
	.seccion-header {
		background-color: #f44336; // Rojo para CUBIERTA
		border-bottom-color: #d32f2f;
	}
}

.seccion-fonda {
	.seccion-header {
		background-color: #4caf50; // Verde para FONDA
		border-bottom-color: #388e3c;
	}
}

.seccion-puente {
	.seccion-header {
		background-color: #2196f3; // Azul para PUENTE
		border-bottom-color: #1976d2;
	}
}

// Colores de fondo por grupo (MAQUINAS) - Copiados de GestionarPropuestas.vue
.grupo-ag {
	.grupo-header { background-color: #b3d9ff; }
	.table-row { background-color: rgba(179, 217, 255, 0.2); }
}
.grupo-bm {
	.grupo-header { background-color: #c8e6c9; }
	.table-row { background-color: rgba(200, 230, 201, 0.2); }
}
.grupo-cf {
	.grupo-header { background-color: #ffe0b2; }
	.table-row { background-color: rgba(255, 224, 178, 0.2); }
}
.grupo-ca {
	.grupo-header { background-color: #f8bbd0; }
	.table-row { background-color: rgba(248, 187, 208, 0.2); }
}
.grupo-dp {
	.grupo-header { background-color: #b2dfdb; }
	.table-row { background-color: rgba(178, 223, 219, 0.2); }
}
.grupo-el {
	.grupo-header { background-color: #fff9c4; }
	.table-row { background-color: rgba(255, 249, 196, 0.2); }
}
.grupo-fl {
	.grupo-header { background-color: #e1bee7; }
	.table-row { background-color: rgba(225, 190, 231, 0.2); }
}
.grupo-fr {
	.grupo-header { background-color: #b3e5fc; }
	.table-row { background-color: rgba(179, 229, 252, 0.2); }
}
.grupo-ga {
	.grupo-header { background-color: #c5cae9; }
	.table-row { background-color: rgba(197, 202, 233, 0.2); }
}
.grupo-ep {
	.grupo-header { background-color: #ffe082; }
	.table-row { background-color: rgba(255, 224, 130, 0.2); }
}
.grupo-he {
	.grupo-header { background-color: #dcedc8; }
	.table-row { background-color: rgba(220, 237, 200, 0.2); }
}
.grupo-hi {
	.grupo-header { background-color: #d1c4e9; }
	.table-row { background-color: rgba(209, 196, 233, 0.2); }
}
.grupo-hd {
	.grupo-header { background-color: #b2ebf2; }
	.table-row { background-color: rgba(178, 235, 242, 0.2); }
}
.grupo-mt {
	.grupo-header { background-color: #e0e0e0; }
	.table-row { background-color: rgba(224, 224, 224, 0.3); }
}
.grupo-mo {
	.grupo-header { background-color: #cfd8dc; }
	.table-row { background-color: rgba(207, 216, 220, 0.2); }
}
.grupo-mp {
	.grupo-header { background-color: #c8e6c9; }
	.table-row { background-color: rgba(200, 230, 201, 0.2); }
}
.grupo-pr {
	.grupo-header { background-color: #ffe0b2; }
	.table-row { background-color: rgba(255, 224, 178, 0.2); }
}
.grupo-ne {
	.grupo-header { background-color: #f8bbd0; }
	.table-row { background-color: rgba(248, 187, 208, 0.2); }
}
.grupo-pp {
	.grupo-header { background-color: #b2dfdb; }
	.table-row { background-color: rgba(178, 223, 219, 0.2); }
}
.grupo-pi {
	.grupo-header { background-color: #fff9c4; }
	.table-row { background-color: rgba(255, 249, 196, 0.2); }
}
.grupo-pc {
	.grupo-header { background-color: #e1bee7; }
	.table-row { background-color: rgba(225, 190, 231, 0.2); }
}
.grupo-qu {
	.grupo-header { background-color: #b3e5fc; }
	.table-row { background-color: rgba(179, 229, 252, 0.2); }
}
.grupo-ss {
	.grupo-header { background-color: #c5cae9; }
	.table-row { background-color: rgba(197, 202, 233, 0.2); }
}
.grupo-si {
	.grupo-header { background-color: #ffe082; }
	.table-row { background-color: rgba(255, 224, 130, 0.2); }
}
.grupo-sb {
	.grupo-header { background-color: #dcedc8; }
	.table-row { background-color: rgba(220, 237, 200, 0.2); }
}
.grupo-tr {
	.grupo-header { background-color: #d1c4e9; }
	.table-row { background-color: rgba(209, 196, 233, 0.2); }
}
.grupo-va {
	.grupo-header { background-color: #b2ebf2; }
	.table-row { background-color: rgba(178, 235, 242, 0.2); }
}
.grupo-vr {
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); }
}

// Colores de fondo por grupo para PUENTE - Sección CUBIERTA
.grupo-cj {
	.grupo-header { background-color: #ebeef1; }
	.table-row { background-color: rgba(235, 238, 241, 0.3); }
}
.grupo-ch {
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); }
}
.grupo-hf {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); }
}
.grupo-jp {
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); }
}
.grupo-ql {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); }
}

// Colores de fondo por grupo para PUENTE - Sección FONDA
.grupo-li {
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); }
}
.grupo-me {
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); }
}

// Colores de fondo por grupo para PUENTE - Sección PUENTE
.grupo-ll {
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); }
}
.grupo-se {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); }
}

// Estilos específicos para VARIOS en sección PUENTE
.seccion-puente .grupo-vr {
	.grupo-header { background-color: #ebeef1; }
	.table-row { background-color: rgba(235, 238, 241, 0.3); }
}

// Estilos específicos para VARIOS en sección FONDA
.seccion-fonda .grupo-vr {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); }
}

@media (max-width: 768px) {
	.propuesta-header .header-row {
		grid-template-columns: 1fr;
	}

	.table-header,
	.table-row {
		grid-template-columns: 36px 60px 1fr 1.5fr 80px 100px 130px 120px 100px minmax(80px, 0.7fr) 120px;
		font-size: 0.85rem;
	}
}

.form-orden-compra-descuento-general {
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;

	.form-orden-compra-suffix {
		flex-shrink: 0;
		font-weight: 600;
		color: #606266;
	}
}

.modal-lanzar-oferta {
	.preview-oferta-section {
		margin-top: 16px;
	}

	.preview-oferta-titulo {
		margin: 0 0 8px;
		font-size: 0.9rem;
		font-weight: 600;
		color: #303133;
	}

	.preview-oferta-vacio {
		margin: 0;
		padding: 12px;
		text-align: center;
		font-size: 0.85rem;
		color: #909399;
		background-color: #f5f7fa;
		border: 1px solid #ebeef5;
		border-radius: 4px;
	}

	.form-orden-compra-preview {
		margin-top: 16px;
	}

	.form-orden-compra-preview-row {
		.el-form-item {
			margin-bottom: 0;
		}
	}

	.preview-orden-compra-totales {
		margin-top: 12px;
		padding: 12px 14px;
		background: #f5f7fa;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		max-width: 360px;
		margin-left: auto;
	}

	.preview-orden-compra-totales-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 16px;
		padding: 4px 0;
		font-size: 0.88rem;
		color: #606266;

		strong {
			color: #303133;
			font-variant-numeric: tabular-nums;
		}

		&--total {
			margin-top: 6px;
			padding-top: 8px;
			border-top: 1px solid #dcdfe6;
			font-size: 0.95rem;
			font-weight: 600;
			color: #303133;
		}
	}
}

// Campos no editables: texto legible (Element UI usa #c0c4cc en .is-disabled)
.gestionar-propuestas-compras-page ::v-deep .el-input.is-disabled .el-input__inner,
.gestionar-propuestas-compras-page ::v-deep .el-textarea.is-disabled .el-textarea__inner,
.gestionar-propuestas-compras-page ::v-deep .el-input-number.is-disabled .el-input__inner {
	color: #606266;
}
</style>
